import BUILDING_INSPECTION from './buildingInspection';
import ENERGY_LABEL_LEADS from './energyLabelLeads';

const ITALIAN = {
  type: 'it-IT',
  languageNames: {
    en: 'Inglese',
    no: 'Norvegese',
    nb: 'Norvegese',
    de: 'Tedesco',
    fr: 'Francese',
    sv: 'Svedese',
    se: 'Svedese',
    da: 'Danese',
    it: 'Italiano',
    fi: 'Finlandese',
  },
  global: {
    noDataAvailable: 'Nessun dato disponibile',
    move: 'Sposta',
    rotate: 'Ruota',
    model: 'Modello',
    data: 'Dati',
    all: 'Tutti',
    controls: 'Controlli',
    lastUpdated: 'Ultimo aggiornamento',
    noData: 'Nessun dato',
    custom: 'Personalizzato',
    name: 'Nome',
    setpoints: 'Setpoint',
    email: 'Email',
    date: 'Data',
    timestamp: 'Data e ora',
    address: 'Indirizzo',
    street: 'Via',
    postcode: 'CAP',
    add: 'Aggiungi',
    city: 'Città',
    country: 'Paese',
    language: 'Lingua',
    timezone: 'Fuso orario',
    new: 'Nuovo',
    from: 'Da',
    until: 'A',
    selectStartDate: 'Seleziona la data di inizio',
    selectEndDate: 'seleziona la data di fine',
    copied: 'Copiato',
    average: 'Media',
    min: 'Min',
    max: 'Max',
    last: 'Ultimo',
    type: 'Tipo',
    role: 'Ruolo',
    category: 'Categoria',
    description: 'Descrizione',
    status: 'Stato',
    public: 'Pubblico',
    active: 'Attivo',
    inactive: 'Inattivo',
    hidden: 'Nascosto',
    visible: 'Visibile',
    show: 'Mostra',
    hide: 'Nascondi',
    enabled: 'Abilitato',
    disabled: 'Disabilitato',
    actionRequired: 'Azione richiesta',
    success: 'Successo',
    none: 'Nessuno',
    error: 'Errore',
    basicInfo: 'Informazioni di base',
    information: 'Informazioni',
    display: 'Visualizzazione',
    save: 'Salva',
    saving: 'Salvataggio…',
    saveSuccess: 'Salvato',
    saveError: 'Impossibile salvare',
    search: 'Cerca',
    close: 'Chiudi',
    confirm: 'Conferma',
    yes: 'Sì',
    no: 'No',
    cancel: 'Annulla',
    update: 'Aggiorna',
    updating: 'Aggiornamento...',
    undo: 'Annulla',
    done: 'Fine',
    delete: 'Elimina',
    discard: 'Ignora',
    rename: 'Rinomina',
    editName: 'Modifica nome',
    download: 'Scarica',
    open: 'Apri',
    password: 'Password',
    login: 'Accedi',
    loginWithAzure: 'Accedi con Azure',
    invalidCredentials: 'Credenziali non valide',
    loginTooManyAttempts:
      'Troppi tentativi di accesso, riprova tra qualche minuto',
    loginInactiveUser: 'Questo account utente non è più attivo',
    loginUnavailable:
      'Impossibile accedere in questo momento, riprova più tardi',
    welcome: 'Benvenuto in Sastech',
    loginSubtitle: 'Accedi per visualizzare la tua dashboard',
    or: 'oppure',
    key: 'Chiave',
    back: 'Indietro',
    apply: 'Applica',
    inDevelopment: 'In sviluppo',
    notAuthorized: 'Non autorizzato',
    heating: 'Riscaldamento',
    cooling: 'Raffreddamento',
    ventilation: 'Ventilazione',
    climate: 'Clima interno',
    battery: 'Batteria',
    batteries: 'Batterie',
    capabilities: 'Funzionalità',
    moveTo: 'Sposta in',
    building: 'Edificio',
    buildings: 'Edifici',
    floor: 'Piano',
    floors: 'Piani',
    sensors: 'Sensori',
    sensor: 'Sensore',
    controller: 'Controller',
    energySource: 'Fonte di energia',
    session: 'Sessione',
    addDevice: 'Aggiungi dispositivo',
    device: 'Dispositivo',
    devices: 'Dispositivi',
    selectDevice: 'Seleziona un dispositivo',
    edit: 'Modifica',
    serialNumber: 'Numero di serie',
    trash: 'Cestino',
    actions: 'Azioni',
    restore: 'Ripristina',
    emptyTrash: 'Svuota cestino',
    selectCategory: 'Seleziona...',
    create: 'Crea',
    monthChartText: [
      'Gen',
      'Feb',
      'Mar',
      'Apr',
      'Mag',
      'Giu',
      'Lug',
      'Ago',
      'Set',
      'Ott',
      'Nov',
      'Dic',
    ],
    today: 'Oggi',
    weekdaysShort: ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'],
    weekdays: [
      'Domenica',
      'Lunedì',
      'Martedì',
      'Mercoledì',
      'Giovedì',
      'Venerdì',
      'Sabato',
    ],
    title: 'Titolo',
    to: 'a',
    remove: 'Rimuovi',
    inspect: 'Ispeziona',
    compare: 'Confronta',
    export: 'Esporta',
    total: 'Totale',
    activate: 'Attiva',
    color: 'Colore',
    text: 'Testo',
    link: 'Link',
    frame: 'Riquadro',
    info: 'Info',
    saveChanges: 'Salva modifiche',
    sidebarMenu: 'Barra laterale',
    icons: 'Icone',
    ok: 'OK',
    exit: 'Esci',
    exportImage: 'Esporta immagine',
    exportSelected: 'Esporta selezionati',
    directions: {
      top: 'Alto',
      bottom: 'Basso',
      right: 'Destra',
      left: 'Sinistra',
      front: 'Fronte',
      back: 'Retro',
      isometric: 'Isometrica',
    },
    switchVendor: 'Cambia cliente',
    searchVendors: 'Cerca clienti...',
    noVendorsFound: 'Nessun cliente trovato',
  },
  chart: {
    zoomIn: 'Ingrandisci',
    zoomOut: 'Riduci',
    rotate: 'Ruota',
    fullscreen: 'Schermo intero',
    rotateTip: 'Clicca e trascina per ruotare il grafico',
  },
  data: {
    loading: 'Caricamento...',
    loadingData: 'Caricamento dati...',
    noResults: 'Nessun risultato trovato.',
    error: 'Errore',
    failedToLoadData: 'Impossibile caricare i dati',
    noDataAvailable: 'Nessun dato disponibile',
  },
  general: {
    temperature: 'Temperatura',
    co2: 'CO₂',
    humidity: 'Umidità',
    zone: 'Zona',
    data: 'Dati',
    edit: 'Modifica',
    analyze: 'Analizza',
    chartType: 'Tipo di grafico',
    toggleSeries: 'Attiva/disattiva serie',
    resetFilters: 'Reimposta filtri',
    exportData: 'Esporta dati',
  },
  chat: {
    title: 'Sastech Chat',
    placeholder: 'Scrivi qui il tuo messaggio…',
    send: 'Invia',
    unknownUser: 'Utente sconosciuto',
  },
  navigation: {
    dashboard: 'Dashboard',
    eosDashboard: 'Panoramica',
    devices: 'Dispositivi',
    map: 'Mappa',
    buildings: 'Edifici',
    reports: 'Report',
    settings: 'Impostazioni',
    logout: 'Disconnetti',
    sastech: 'Impostazioni Sastech',
    analytics: 'Analitica',
    buildings3D: 'Edifici 3D',
    superSettings: 'Sastech',
    buildingInspection: 'Ispezione',
    expandSidebar: 'Espandi barra laterale',
    collapseSidebar: 'Comprimi barra laterale',
    userCalendar: 'Calendario Utente',
    energyLabelLeads: 'Lead etichettatura energetica',
  },
  reports: {
    title: 'Report',
    orderReport: 'Ordina report',
    orderDescription: 'Il report compare nell’elenco quando è pronto.',
    reportType: 'Tipo di report',
    kinds: {
      eos_weekly: 'Report energetico settimanale',
      eos_monthly: 'Report energetico mensile',
    },
    period: 'Periodo',
    week: 'Settimana {week}',
    reportLanguage: 'Lingua del report',
    submit: 'Ordina',
    submitting: 'Ordine in corso…',
    status: {
      queued: 'In coda',
      generating: 'In creazione',
      completed: 'Pronto',
      failed: 'Non riuscito',
    },
    exportExcel: 'Scarica Excel',
    exportPdf: 'Scarica PDF',
    makePdf: 'Crea PDF',
    pdfPending: 'PDF in creazione…',
    confirmDeleteTitle: 'Elimina report',
    confirmDeleteMessage:
      "Il report viene rimosso dall'elenco. L'operazione non può essere annullata.",
    noReports: 'Nessun report ancora. Ordina il primo.',
    noSearchHits: 'Nessun report corrisponde alla ricerca.',
    noMeters: "L'edificio non ha contatori di energia attivi.",
    duplicateOrder: 'Lo stesso report è già in creazione.',
    orderError: 'Impossibile ordinare il report',
    orderSuccess: 'Il report è stato ordinato ed è in creazione.',
    deleteError: 'Impossibile eliminare il report',
    pdfError: 'Impossibile ordinare il PDF',
    pdfRequested: 'Il PDF è stato ordinato ed è in creazione.',
    requestedBy: 'Ordinato da',
    ordered: 'Ordinato',
    daysAgo: '{count} giorni fa',
    sheets: {
      summary: 'Riepilogo',
      days: 'Per giorno',
      hours: 'Per ora',
      sources: 'Contatori',
      profile: 'Profilo giornaliero',
    },
    excel: {
      parameter: 'Parametro',
      value: 'Valore',
      unit: 'Unità',
      delivered: 'Energia fornita',
      production: 'Produzione propria',
      export: 'Esportata',
      net: "Usata nell'edificio",
      baseline: 'Riferimento',
      previousYear: 'Anno precedente',
      co2: 'CO2',
      baselineCo2: 'CO2 di riferimento',
      hoursWithData: 'Ore con dati',
      meanKW: 'Potenza media',
      maxKW: 'Ora più alta',
      maxAt: 'Ora più alta, momento',
      baseLoadKW: 'Carico di base',
      nightKW: 'Carico notturno 00–05',
      peakHours: 'Ore al 90 % del massimo o oltre',
      weekday: 'Giorno della settimana',
      time: 'Ora',
      source: 'Contatore',
      missingHours: 'Ore mancanti',
      energy: 'Energia',
      co2Factor: 'Fattore CO2',
      role_delivered: 'energia fornita',
      role_production: 'produzione propria',
      role_export: 'esportazione',
      role_excluded: 'non conteggiato',
    },
  },
  map: {
    addBuildingAtCenter: 'Aggiungi edificio al centro della mappa',
  },
  pagination: {
    rowsPerPage: 'Righe per pagina',
    rangeSeparator: 'di',
  },
  devices: {
    title: 'Panoramica Dispositivi',
    reset: 'Reimposta',
    noDevices: 'Nessun dispositivo trovato.',
    unnamed: 'Dispositivo senza nome',
    copySensorTag: 'Copia tag sensore',
    graph: {
      inspect: 'Ispeziona',
      edit: 'Modifica',
      chartType: 'Tipo di grafico',
      toggleSeries: 'Alterna serie',
      resetFilters: 'Reimposta filtri',
      exportData: 'Esporta dati',
      noData: 'Nessun dato',
      bar: 'Barre',
      line: 'Linea',
      pie: 'Torta',
      scatter: 'Dispersione',
      radar: 'Radar',
    },
    categoryFilter: {
      filter: 'Filtra',
      filterByCategory: 'Filtra per categoria',
      selectAll: 'Seleziona tutto',
      clearAll: 'Cancella tutto',
      searchCategories: 'Cerca categorie...',
      noCategories: 'Nessuna categoria trovata',
      noData: 'Nessun dato',
      devices: 'dispositivi',
      selected: 'Selezionati',
      category: 'categoria',
      categories: 'categorie',
      more: 'altri',
    },
    detailLevel: {
      label: 'Livello di dettaglio',
      units: {
        minutes: 'Minuti',
        minutesShort: 'min',
        day: 'Giorno',
      },
    },
    dateRange: {
      startLabel: 'Data di Inizio',
      endLabel: 'Data di Fine',
    },
    eosConsumption: {
      card: {
        dateLabel: 'Data',
        total: {
          production: 'Produzione totale:',
          consumption: 'Consumo totale:',
        },
        highestPeak: 'Picco massimo:',
        calculatedPrice: {
          eur: 'Prezzo calcolato (EUR):',
          nok: 'Prezzo calcolato (NOK):',
        },
      },
    },
  },
  analytics: {
    session: {
      moreActions: 'Altre azioni',
      newSession: 'Nuova sessione',
      unsaved: 'Modifiche non salvate',
      namePlaceholder: 'Nome sessione',
      deleteTitle: 'Eliminare la sessione?',
      deleteDescription:
        'Questa operazione rimuove definitivamente la sessione salvata e la sua selezione di dispositivi.',
      noSessions: 'Nessuna sessione salvata',
      discardTitle: 'Ignorare le modifiche non salvate?',
      discardDescription:
        'La sessione corrente contiene modifiche non salvate. Cambiando sessione andranno perse.',
    },
    notifications: {
      overlayMissingZone:
        "Nessuna zona configurata per l'edificio. Viene usato il valore predefinito (NO1).",
      overlayMissingRate: 'Impossibile recuperare il tasso di cambio',
      overlayFetchFailed: 'Impossibile caricare i dati di sovrapposizione',
      sessionSaved: 'Sessione salvata',
      sessionCreated: 'Sessione creata',
      sessionDeleted: 'Sessione eliminata',
      sessionSaveFailed: 'Impossibile salvare la sessione',
      sessionDeleteFailed: 'Impossibile eliminare la sessione',
      sessionsLoadFailed: 'Impossibile caricare le sessioni salvate',
      devicesLoadFailed: 'Impossibile caricare i dispositivi',
      buildingsLoadFailed: 'Impossibile caricare gli edifici',
      readingsLoadFailed:
        'Impossibile caricare le letture di uno o più dispositivi',
      nameRequired: 'Assegna un nome alla sessione prima di salvare',
      rangeTooWide:
        'Gli intervalli superiori a 7 giorni sono lenti con questo campionamento. Passa a Giornaliero per prestazioni migliori.',
    },
    title: 'Analisi in tempo reale & KPI',
    pageTitle: 'Analitica',
    searchPlaceholder: 'Cerca dispositivi…',
    buttons: {
      toggleSidebar: 'Mostra/nascondi elenco dispositivi',
      showAll: 'Mostra tutto',
      hideAll: 'Nascondi tutto',
      showTrends: 'Mostra tendenze',
      hideTrends: 'Nascondi tendenze',
      clearAll: 'Cancella tutto',
      export: 'Esporta',
    },
    exportMenu: {
      exportAsPNG: 'Esporta come PNG',
      exportAsCSV: 'Esporta come CSV',
    },
    thresholds: {
      max: 'Max:',
      min: 'Min:',
      aboveThreshold: 'Sopra la soglia',
      belowThreshold: 'Sotto la soglia',
    },
    timeAxis: {
      label: 'Asse temporale',
      actual: 'Tempo effettivo',
      timeOfDay: 'Ora del giorno',
      dayOfWeek: 'Giorno della settimana',
      dayOfMonth: 'Giorno del mese',
      bucket: 'Raggruppa per',
    },
    legend: {
      manage: 'Gestisci',
      overlays: 'Sovrapposizioni',
      series: 'Serie',
      trends: 'Tendenze',
      more: 'altri',
    },
    overlay: {
      weatherAndElectricity: 'Meteo & Elettricità',
      none: 'Nessuno',
      outsideTemperature: 'Temperatura esterna',
      elecPrice: 'Prezzo elett.',
      elecPriceFull: 'Prezzo elett. (€/kWh)',
      loadingData: 'Caricamento dati...',
    },
    collab: {
      viewingSession: 'sta visualizzando questa sessione',
      updatedSession: 'ha aggiornato questa sessione',
      deletedSession: 'ha eliminato questa sessione',
      conflictTitle: 'Qualcuno ha salvato una versione più recente',
      conflictDescription:
        'Questa sessione è stata salvata da qualcun altro mentre la stavi modificando. Carica la loro versione (le tue modifiche andranno perse) o sovrascrivila con la tua.',
      loadTheirs: 'Carica la loro versione',
      overwrite: 'Sovrascrivi',
    },
    picker: {
      wholeBuilding: 'Intero edificio',
      noClimateSources: 'Nessun edificio con zone',
      noAveragesData: 'Ancora nessun dato climatico',
      noIndoorSensors: "L'edificio non ha sensori interni",
      inSession: 'Nella sessione',
      searchBuildings: 'Cerca edifici…',
      noBuildingsMatch: 'Nessun edificio corrisponde',
      noWeatherData: 'Ancora nessun dato meteo',
    },
    devices: {
      noDevicesMatch: 'Nessun dispositivo corrispondente',
      unnamedDevice: 'Dispositivo senza nome',
      noDevicesSelected: 'Nessun dispositivo selezionato',
      devicesFound: 'dispositivi trovati',
      noDevicesMatchSearch: 'Nessun dispositivo corrisponde alla tua ricerca',
      deviceSelected: 'dispositivo selezionato',
      devicesSelected: 'dispositivi selezionati',
      shown: 'mostrati',
      total: 'totale',
    },
    chart: {
      zoomHint: 'Ingrandito (doppio clic per reimpostare)',
      loadingChartData: 'Caricamento dati del grafico...',
      addDevicesToVisualize: 'Aggiungi dispositivi per visualizzare i dati',
    },
    liveEvents: {
      title: 'Eventi in diretta',
      events: 'eventi',
      waitingForEvents: 'In attesa di eventi…',
    },
    modal: {
      weatherIntervalHint: 'I dati meteo hanno risoluzione oraria',
      deviceSettings: 'Impostazioni dispositivo',
      addDevices: 'Aggiungi dispositivi',
      clear: 'Cancella',
      startTime: 'Ora di inizio',
      endTime: 'Ora di fine',
      samplingInterval: 'Intervallo di campionamento',
      dataAggregationGranularity: 'Granularità di aggregazione dati',
      startMustBeBeforeEnd: "L'inizio deve essere prima della fine",
      intervals: {
        fiveMinutes: '5 minuti',
        fifteenMinutes: '15 minuti',
        oneHour: '1 ora',
        daily: 'Giornaliero',
      },
    },
    connectionStatus: {
      error: 'ERRORE',
      connected: 'CONNESSO',
      connecting: 'CONNESSIONE',
      disconnected: 'DISCONNESSO',
    },
  },
  eosDashboard: {
    headerTitle: 'Panoramica energetica',
    energyKnowledge: {
      title: 'Analisi energetica',
      lastMonth: 'Mese scorso',
    },
    building: 'Edificio',
    selectBuilding: 'Seleziona edificio',
    outdoorTemperature: 'Temperatura esterna',
    noData: 'N/D',
    electricityPrice: 'Prezzo dell’elettricità',
    electricityPrices: 'Prezzi dell’elettricità',
    noPriceData: 'Nessun dato sui prezzi disponibile.',
    electricityConsumption: 'Consumo di elettricità',
    baseline: 'Baseline',
    viewLabel: 'Vista:',
    aggregated: 'Aggregato',
    meteringPoint: 'Punto di misura:',
    individualTitle: 'Punti di misura individuali',
    eosSourcesTitle: 'Dispositivi EOS individuali',
    footprint: 'Impronta CO₂ (Riduzione)',
    co2Footprint: 'Impronta CO₂',
    consumption: 'Consumo',
    avgMaxKwp: 'Potenza massima media kWp',
    higher: 'Più alto',
    lower: 'Più basso',
    normal: 'Normale',
    priceWord: 'prezzo',
    vsAverage: 'Rispetto alla media',

    baselineChart: {
      total: 'Totale',
      average: 'Media',
      leftAxis: 'kWh (Consumo)',
      rightAxis: 'kWp (Massimo medio)',
      co2Avg: 'CO₂ medio',
      missingData: 'Dati mancanti',
      missingDataDescription: 'Valori mancanti per questo mese',
    },
    energyLabel: {
      title: 'Etichetta energetica dinamica',
      withoutSastech: 'Etichetta ufficiale',
      withSastech: 'Etichetta dinamica',
      deliveredEnergy: 'Energia consegnata calcolata',
      insufficientData:
        "Solo {months} mesi di dati disponibili. L'etichetta potrebbe non essere rappresentativa.",
      noFloorArea:
        'La superficie utile netta non è impostata per questo edificio.',
      noBuildingCategory:
        "La categoria dell'edificio non è impostata per questo edificio.",
      fossilFuelShare: 'Quota di elettricità/olio/gas',
      reduction: 'Riduzione',
      floorArea: 'Superficie utile',
      annualConsumption: 'Annuale',
      energyGrade: 'Classe energetica',
      labels: {
        A: 'Molto efficiente dal punto di vista energetico',
        B: 'Efficiente dal punto di vista energetico',
        C: 'Efficienza moderata',
        D: 'Sotto la media',
        E: 'Bassa efficienza',
        F: 'Molto bassa efficienza',
        G: 'La meno efficiente',
      },
    },
    kpiSection: {
      noChange: '0.0',

      units: {
        kWh: 'kWh',
        kg: 'kg',
        kgCo2: 'kg CO₂',
        krPerKWh: 'kr/kWh',
        degC: '°C',
      },

      trend: {
        increaseSign: '+{percent}%',
        decreaseSign: '-{percent}%',
        neutral: '0.0',
        aboveAverage: 'Sopra',
        belowAverage: 'Sotto',
        atAverage: 'Al',
        averageThisPeriod: 'media di questo periodo',
      },

      consumption: {
        title: 'Consumo totale',
        value: '{value} {unit}',
        subtitle: {
          increased: 'Aumentato di {delta} {unit}',
          reduced: 'Ridotto di {delta} {unit}',
          noChange: 'Nessun cambiamento nei consumi',
          noBaseline: 'Nessun dato di riferimento disponibile',
        },
        detail: 'Consumo energetico negli ultimi {periodLabel}',
      },

      co2: {
        title: 'Impronta totale di CO₂',
        value: '{value} {unit}',
        subtitle: {
          reduced: 'Ridotto di {delta} {unit}',
          increased: 'Aumentato di {delta} {unit}',
          noChange: 'Nessun cambiamento nelle emissioni',
          noBaseline: 'Nessun dato di riferimento disponibile',
        },
        detail: 'Impronta di carbonio negli ultimi {periodLabel}',
      },

      adjustedConsumption: {
        title: 'Consumo corretto per gradi giorno',
      },

      estate: {
        title: 'Edifici e fonti',
        value: '{count} edifici',
        subtitle: '{count} numero totale di fonti',
        detail: 'Attualmente {count} dispositivi attivi',
      },

      price: {
        title: 'Prezzo attuale',
        value: '{value} {unit}',
        subtitle: '{direction} {avgPhrase}',
        detail: 'Prezzo dell’elettricità in questo momento',
      },

      temperature: {
        title: 'Temperatura',
        value: '{value}{unit}',
        chipDelta: '{signedDelta}{unit}',
        subtitleText: '{text}',
        detail: 'Condizioni meteo attuali',
      },
    },
    savingsSection: {
      consumptionComparison: {
        title: 'Confronto dei consumi - anno scorso vs anno in corso',
        baseLineLabel: 'Baseline',
        peakHourlyLabel: 'Picco orario',
      },
      consumptionSavings: {
        title: `Risparmio di consumo - baseline vs. {{currentYear}}`,
      },
    },
    electricityChart: {
      totalLabel: 'Totale',
      totalEnergyConsumption: 'Consumo energetico totale',
      totalElectricityConsumption: 'Consumo elettrico totale',
      energyConsumption: 'Consumo energetico',
      electricityConsumption: 'Consumo elettrico',
      noDataForSelectedPeriod: 'Nessun dato per il periodo selezionato',
      meteringPointTitle: 'Punto di misura: {id}',
      sourceTitle: 'Fonte: {id}',
      unknownLabel: 'Sconosciuto',
      unknownIdLabel: 'ID sconosciuto',
      powerFactorLabel: 'Fattore di potenza Cos φ',
      powerFactorWarning:
        'Un fattore di potenza inferiore a 0,95 può comportare penalità tariffarie',
      renameDialog: {
        title: 'Rinomina punto di misurazione',
        label: 'Nome visualizzato',
        helpTextPrefix: 'ID originale del punto di misurazione',
      },
      errors: {
        loadAggregatedData: 'Caricamento dei dati aggregati non riuscito',
        loadFilteredData: 'Caricamento dei dati filtrati non riuscito',
        fetchDisplayName: 'Recupero del nome visualizzato non riuscito',
        invalidDisplayName: 'Fornire un nome visualizzato valido',
        renameFailed: 'Rinomina del dispositivo EOS non riuscita',
        renameUnknown:
          'Si è verificato un errore durante la rinomina del dispositivo EOS',
        noDataToExport: 'Nessun dato disponibile per l’esportazione',
        exportFailedTitle: 'Esportazione non riuscita',
        exportFailedPrefix: 'Esportazione dei dati non riuscita',
        unknownError: 'Errore sconosciuto',
        enterValidDisplayName: 'Inserire un nome visualizzato valido',
        validationErrorTitle: 'Errore di validazione',
      },
      tooltip: {
        electricityElhub: 'Elettricità',
        reactiveEnergy: 'Energia reattiva',
        buildingsLabel: 'Edifici',
        meteringPointsLabel: 'Punti di misura',
        districtHeating: 'Teleriscaldamento',
        solarPv: 'Energia solare prodotta',
        exportedElectricity: 'Elettricità esportata',
      },
    },
    co2BarChart: {
      baseline: 'Valore di riferimento',
      legendBaseline: 'Baseline',
      currentValues: 'Valori attuali',
      co2Emissions: 'Emissioni di CO₂',
      dailyEmissions: 'Emissioni giornaliere',
      monthlyEmissions: 'Emissioni mensili',
      months: [
        'Gennaio',
        'Febbraio',
        'Marzo',
        'Aprile',
        'Maggio',
        'Giugno',
        'Luglio',
        'Agosto',
        'Settembre',
        'Ottobre',
        'Novembre',
        'Dicembre',
      ],
      goal: 'Obiettivo',
    },
    chartMenu: {
      rename: 'Rinomina',
      exportExcel: 'Esporta Excel',
      exportCSV: 'Esporta CSV',
    },
    periodOptions: {
      '3days': {
        label: 'Ultimi 3 giorni',
        mobileLabel: '3 giorni',
        chartLabel: '3 giorni',
      },
      '30days': {
        label: 'Ultimi 30 giorni',
        mobileLabel: '30 giorni',
        chartLabel: '30 giorni',
      },
      '3months': {
        label: 'Ultimi 3 mesi',
        mobileLabel: '3 mesi',
        chartLabel: '3 mesi',
      },
    },
    chartSubtitle: {
      today: 'Totale per oggi',
      oneDay: 'Totale per 1 giorno',
      days: 'Totale per {days} giorni',
      oneWeek: 'Totale per 1 settimana',
      weekAndDays: 'Totale per 1 settimana e {days} giorno/i',
      weeks: 'Totale per {weeks} settimane',
      weeksAndDays: 'Totale per {weeks} settimane e {days} giorno/i',
      months: 'Totale per {months} mesi',
      monthsAndDays: 'Totale per {months} mesi e {days} giorno/i',
      monthsAndWeeks: 'Totale per {months} mesi e {weeks} settimana/e',
    },
    datePicker: {
      startLabel: 'Inizio',
      endLabel: 'Fine',
    },
    weatherTemperature: {
      noData: 'Nessun dato meteo disponibile',
      headerTitle: 'Previsioni meteo',
      headerSubtitle: 'Previsione',
      tooltip: {
        conditions: 'Condizioni',
        temperature: 'Temperatura',
        wind: 'Vento',
        windDirection: 'Direzione del vento',
        pressure: 'Pressione',
        cloudCover: 'Copertura nuvolosa',
        fog: 'Nebbia',
        uvIndex: 'Indice UV',
        precipitation: 'Precipitazioni prossima ora',
      },
      stats: {
        min: 'Min',
        avg: 'Media',
        max: 'Max',
        current: 'Attuale',
      },
    },
    tempTrend: {
      stable: 'Temperatura esterna stabile',
      graduallyRising: 'Temperatura in aumento graduale',
      graduallyFalling: 'Temperatura in diminuzione graduale',
      rising: 'Temperatura esterna in aumento',
      falling: 'Temperatura esterna in diminuzione',
    },
    noDataForPeriod: 'Nessun dato energetico per il periodo selezionato',
    totalEnergy: 'Energia totale',
    filters: {
      noMatch: 'Nessun nodo corrisponde a tutte le categorie selezionate',
    },
    staleData: {
      warningText: 'i dati di ieri non sono disponibili',
      showingDataFrom: 'Visualizzazione dati del',
    },
    sankey: {
      noData: 'Nessun dato Sankey disponibile.',
      searchNodes: 'Cerca nodi...',
      selectedNodes: 'Nodi selezionati',
      csvValue: 'Valore (kWh)',
      csvDeviceId: 'ID dispositivo',
    },
  },
  superSettings: {
    securityLog: {
      title: 'Registro di sicurezza',
      levelBadge: 'Livello 10',
      intro:
        "Accessi, modifiche, accesso ai dati e uso dell'API per tutti i clienti. Accessi, modifiche e accesso ai dati sono conservati per 90 giorni, l'uso per 30 giorni.",
      error: 'Impossibile caricare il registro di sicurezza.',
      tabs: {
        overview: 'Panoramica',
        logins: 'Accessi',
        changes: 'Modifiche',
        reads: 'Accesso ai dati',
        usage: 'Utilizzo',
        sessions: 'Sessioni',
      },
      filters: {
        period: 'Periodo',
        last24h: 'Ultime 24 ore',
        last7d: 'Ultimi 7 giorni',
        last30d: 'Ultimi 30 giorni',
        last90d: 'Ultimi 90 giorni',
        custom: 'Personalizzato',
        vendor: 'Cliente',
        allVendors: 'Tutti i clienti',
        exportCsv: 'Esporta CSV',
        refresh: 'Aggiorna',
      },
      totals: {
        logins: 'Accessi',
        loginsHint: '{users} utenti, {ips} IP',
        reads: 'Accesso ai dati',
        readsHint: '{users} utenti',
        readsTooltip:
          'Letture di elenchi utenti, elenchi clienti, lead e registri',
        failedLogins: 'Accessi non riusciti',
        rateLimitedHint: '{count} bloccati dal limite di frequenza',
        changes: 'Modifiche',
        deletesHint: '{count} eliminazioni',
        accessChanges: 'Modifiche di accesso',
        accessHint: 'Livelli, accesso clienti, Entra ID',
        requests: 'Richieste API',
        requestsHint: '{users} utenti attivi',
        compromised: 'Forse compromessi',
        compromisedHint: 'Account da controllare',
        unknownOutcome:
          '{count} accessi precedenti alla registrazione degli esiti sono contati a parte.',
        truncated:
          'Il periodo è ampio; sono state controllate solo le prime 20 000 voci.',
      },
      attention: {
        title: 'Da verificare',
        empty: 'Nulla da verificare in questo periodo.',
        high: 'Alta',
        medium: 'Media',
        low: 'Bassa',
        showMore: 'Mostra tutti ({count})',
      },
      compromised: {
        title: 'Account forse compromessi',
        empty: 'Nessun account mostra segni di compromissione.',
        help: 'Un uso che nessuna persona potrebbe produrre, o una sessione usata da più luoghi contemporaneamente.',
      },
      chart: {
        title: 'Accessi al giorno',
        success: 'Riusciti',
        failed: 'Non riusciti',
        rateLimited: 'Limitati',
      },
      sensitive: {
        title: 'Ultime modifiche di accesso',
        empty: 'Nessuna modifica di accesso in questo periodo.',
      },
      alerts: {
        failedLoginsThenSuccess:
          '{count} accessi non riusciti per {who}, poi un accesso riuscito',
        failedLogins: '{count} accessi non riusciti per {who}',
        failedLoginsIp:
          '{count} accessi non riusciti da {ip}, su {accounts} account',
        rateLimited: '{count} tentativi di accesso bloccati per {who}',
        newIp: '{who} ha effettuato l’accesso da un nuovo indirizzo IP ({ip})',
        levelRaised: '{who} portato dal livello {old} al livello {new} da {by}',
        accessChange: 'Accesso modificato per {who} ({fields}) da {by}',
        userDeleted: '{who} è stato eliminato da {by}',
        massDelete: '{who} ha eliminato {count} record in 10 minuti',
        requestBurst: '{who} ha fatto {count} richieste in un minuto',
        alwaysOn: '{who} è stato attivo {count} ore in un giorno',
        parallelLocations:
          '{who} è stato usato da {count} indirizzi IP contemporaneamente',
        parallelDevices:
          '{who} è stato usato da {count} dispositivi contemporaneamente',
        robotRhythm:
          '{who} ha inviato richieste a un ritmo regolare da macchina per {count} minuti',
        changeBurst: '{who} ha fatto {count} modifiche in 10 minuti',
        vendorHopping: '{who} ha lavorato in {count} clienti in un’ora',
        readBurst: '{who} ha letto dati critici {count} volte in 10 minuti',
        unknown: 'Avviso sconosciuto',
        someone: 'account sconosciuto',
        occurrences: '{count} volte nel periodo',
      },
      alertNames: {
        failedLoginsThenSuccess: 'Accesso dopo molti errori',
        failedLogins: 'Molti accessi non riusciti',
        failedLoginsIp: 'IP con errori',
        rateLimited: 'Limitato',
        newIp: 'Nuovo indirizzo IP',
        levelRaised: 'Livello aumentato',
        accessChange: 'Accesso modificato',
        userDeleted: 'Utente eliminato',
        massDelete: 'Eliminazione di massa',
        requestBurst: 'Picco di richieste',
        alwaysOn: 'Sempre attivo',
        parallelLocations: 'Più luoghi insieme',
        parallelDevices: 'Più dispositivi insieme',
        robotRhythm: 'Ritmo da macchina',
        changeBurst: 'Picco di modifiche',
        vendorHopping: 'Cambi di cliente',
        readBurst: 'Lettura massiva',
      },
      logins: {
        time: 'Ora',
        outcome: 'Esito',
        method: 'Metodo',
        account: 'Account',
        vendor: 'Cliente',
        ip: 'Indirizzo IP',
        device: 'Dispositivo',
        allOutcomes: 'Tutti gli esiti',
        allFailures: 'Tutti gli errori',
        allMethods: 'Tutti i metodi',
        searchEmail: 'Cerca e-mail',
        searchIp: 'Indirizzo IP',
        filterByIp: 'Mostra gli accessi da questo IP',
        filterByAccount: 'Mostra gli accessi di questo account',
        empty: 'Nessun accesso corrisponde ai filtri.',
      },
      outcomes: {
        success: 'Riuscito',
        wrong_password: 'Password errata',
        unknown_user: 'Utente sconosciuto',
        inactive: 'Disattivato',
        invalid_input: 'Input non valido',
        rate_limited: 'Limitato',
        unknown_vendor: 'Tenant sconosciuto',
        invalid_session: 'Sessione non valida',
        unknown: 'Non registrato',
      },
      methods: {
        password: 'Password',
        entra: 'Entra ID',
      },
      changes: {
        time: 'Ora',
        action: 'Azione',
        collection: 'Raccolta',
        record: 'Record',
        by: 'Da',
        vendor: 'Cliente',
        endpoint: 'Richiesta',
        history: 'Cronologia',
        allActions: 'Tutte le azioni',
        create: 'Creato',
        update: 'Aggiornato',
        delete: 'Eliminato',
        collectionPlaceholder: 'Raccolta, ad es. users',
        fieldPlaceholder: 'Campo, ad es. level',
        empty: 'Nessuna modifica corrisponde ai filtri.',
        filterByUser: 'Mostra le modifiche di questo utente',
      },
      reads: {
        time: 'Ora',
        user: 'Utente',
        area: 'Cosa',
        vendor: 'Cliente',
        ip: 'Indirizzo IP',
        device: 'Dispositivo',
        allAreas: 'Tutto tranne il registro di sicurezza',
        everything: 'Tutto, incluso il registro di sicurezza',
        searchIp: 'Indirizzo IP',
        filterByUser: 'Mostra le letture di questo utente',
        filterByIp: 'Mostra le letture da questo IP',
        empty: 'Nessuna lettura corrisponde ai filtri.',
        note: 'Letture di elenchi utenti, elenchi clienti, lead e registri, conservate per 90 giorni.',
      },
      readAreas: {
        vendors: 'Elenco clienti',
        users: 'Elenco utenti',
        alarmUsers: 'Utenti allarme',
        energyLabelLeads: 'Lead certificazione energetica',
        enerskyAccess: 'Accesso Enersky',
        feedback: 'Feedback',
        requestLogs: 'Registri delle richieste',
        securityLog: 'Registro di sicurezza',
        other: 'Altro',
      },
      usage: {
        user: 'Utente',
        requests: 'Richieste',
        peak: 'Picco al minuto',
        activeMinutes: 'Minuti attivi',
        ips: 'IP',
        devices: 'Dispositivi',
        vendors: 'Clienti',
        flags: 'Segnalazioni',
        flaggedOnly: 'Solo utenti segnalati',
        compromisedBadge: 'Forse compromesso',
        empty: "Nessun uso dell'API in questo periodo.",
        note: "L'uso dell'API è conservato per 30 giorni.",
      },
      sessions: {
        user: 'Utente',
        rights: 'Diritti',
        method: 'Metodo',
        ip: 'Indirizzo IP',
        device: 'Dispositivo',
        started: 'Accesso',
        lastSeen: 'Visto l’ultima volta',
        status: 'Stato',
        open: 'Aperta',
        revoked: 'Revocata',
        expired: 'Scaduta',
        idle: 'Inattiva',
        level: 'Livello {level}',
        tenants: '+{count} clienti',
        openOnly: 'Solo sessioni aperte',
        revoke: 'Revoca',
        revokeTitle: 'Revocare questa sessione?',
        revokeText: 'La sessione di {who} ({method}, {ip}) viene terminata.',
        cancel: 'Annulla',
        revokeFailed: 'Impossibile revocare la sessione.',
        empty: 'Nessuna sessione corrisponde ai filtri.',
        note: 'Una sessione termina {absolute} ore dopo l’accesso o dopo {idle} ore di inattività. Le sessioni sono conservate per 90 giorni.',
        notEnforced:
          'Le sessioni vengono registrate ma non ancora applicate. La revoca segna la sessione come terminata; l’utente viene disconnesso quando l’applicazione viene attivata.',
      },
      history: {
        title: 'Cronologia del record',
        empty: 'Nessuna modifica registrata per questo record.',
        close: 'Chiudi',
        open: 'Mostra la cronologia di questo record',
      },
    },
    areasMenu: {
      securityLog: 'Registro di sicurezza',
      createDashboard: 'Crea dashboard',
      feedback: 'Feedback',
      projects: 'Progetti',
      icMeter: 'Misuratore IC',
      lakeSensors: 'Sensori del lago',
      eosDevices: 'Dispositivi EOS',
      deviceMapping: 'Mappatura dispositivi',
      energyLabeling: 'Etichettatura energetica',
      alarmSystems: 'Sistemi di allarme',
      enerskyAccess: 'Accesso Enersky',
    },
    dataQuality: {
      title: 'Ispettore qualità dati',
      subtitle:
        'Panoramica in tempo reale di tutti i gruppi di sensori e dello stato dei dati dei dispositivi.',
      noLakes: 'Nessun gruppo di sensori trovato',
      noDevices: 'Nessun dispositivo',
      allReporting: 'Tutti attivi',
      missing: 'mancanti',
      device: 'dispositivo',
      devices: 'dispositivi',
      missingData: 'Dati mancanti',
    },
    createDashboard: {
      header: 'Nuova dashboard cliente',
      sections: {
        companyDetails: 'Dettagli azienda',
        address: 'Indirizzo',
        contactDetails: 'Contatti',
      },
      fields: {
        companyName: 'Nome azienda',
        organizationNumber: 'Numero di registrazione',
        street: 'Via',
        city: 'Città',
        postcode: 'CAP',
        country: 'Paese',
        email: 'Email',
        phoneNumber: 'Numero di telefono',
        timezone: 'Fuso orario del cliente',
      },
      helperText: {
        organizationNumber: 'Numero di registrazione aziendale',
        timezone: 'Seleziona il fuso orario del cliente',
      },
      buttons: {
        cancel: 'Annulla',
        createClient: 'Crea cliente',
      },
    },
    sastechFeedback: {
      title: 'Feedback Sastech',
      table: {
        title: 'Messaggi di Feedback',
        message: 'Messaggio',
        actions: 'Azioni',
        resolved: 'Risolto',
        resolvedBy: 'da',
        unResolved: 'Non risolto',
        filter: 'Filtro',
        developerFeedback: 'Feedback dello sviluppatore',
        comment: 'Commento',
        assignDeveloper: 'Assegna sviluppatore',
        suggestedAction: 'Azione suggerita',
        tags: 'Tag',
        noTagsProvided: 'Nessun tag fornito',
        vote: 'Vota',
        resolvedTicketsThisWeek: 'Ticket risolti questa settimana',
        last7Days: 'Ultimi 7 giorni',
        newTicketsThisWeek: 'Nuovi ticket questa settimana',
        featureTicketsThisWeek: 'Ticket di funzionalità questa settimana',
        bugTicketsThisWeek: 'Ticket di bug questa settimana',
        resolvedTickets: 'Ticket risolti',
      },
      buttons: {
        resolve: 'Risolvi',
        save: 'Salva risposta',
      },
      confirm: {
        resolve: 'Sei sicuro di voler risolvere questo messaggio?',
        delete: 'Sei sicuro di voler eliminare questo messaggio?',
      },
      details: {
        browserInfo: 'Info browser:',
        device: 'Dispositivo',
        operatingSystem: 'Sistema operativo',
        path: 'Percorso',
        resolution: 'Risoluzione',
        na: 'n.d.',
        screenshotAlt: 'screenshot',
      },
    },
    alarmSystems: {
      titleEdit: 'Modifica sistema di allarme',
      accordion: {
        details: 'Dettagli allarme',
        heartbeat: 'Dettagli heartbeat',
        notification: 'Dettagli notifica',
        connectedDevices: 'Allarmi dispositivi collegati',
      },
      fields: {
        systemName: 'Nome del sistema di allarme',
        description: 'Descrizione',
        location: 'Posizione',
        key: 'Chiave',
      },
      heartbeat: {
        explanation:
          'L’intervallo di heartbeat è il tempo in secondi tra ogni segnale inviato dal sistema di allarme al server. Questo segnale indica che il sistema è attivo e funzionante. Se il server non riceve un segnale entro un certo intervallo, potrebbe indicare un problema.',
        monitor: 'Monitor heartbeat',
        hours: 'Ore',
        minutes: 'Minuti',
        seconds: 'Secondi',
      },
      notification: {
        type: 'Tipo di notifica',
        selectType: 'Seleziona tipo notifica',
        options: {
          email: 'Email',
          sms: 'SMS',
        },
        recipient: 'Destinatario notifica',
        recipients: 'Destinatari notifica',
        selectUser: 'Seleziona utente',
        orAddManually:
          'Oppure aggiungi email o numero di cellulare manualmente:',
        addRecipient: 'Aggiungi destinatario',
        contact: 'Email / numero di cellulare',
        minimumSeverity: 'Gravità minima',
        severityLevels: {
          1: 'Info',
          2: 'Avviso',
          3: 'Minore',
          4: 'Maggiore',
          5: 'Critico',
        },
        errors: {
          empty: 'Il destinatario non può essere vuoto',
          duplicate: 'Questo destinatario è già presente',
          invalidEmail: 'Formato email non valido',
          selectTypeFirst: 'Seleziona prima il tipo di notifica',
          enterEmail: 'Inserisci un indirizzo email',
          enterMobile: 'Inserisci un numero di cellulare',
        },
      },
      connectedDevices: {
        empty:
          'Nessun allarme dispositivo è collegato a questo sistema di allarme.',
        unnamed: 'Allarme senza nome',
      },
      titleCreate: 'Crea sistema di allarme',
      confirmDelete: 'Sei sicuro di voler eliminare questo sistema di allarme?',
      list: {
        new: 'Nuovo',
        search: 'Cerca...',
        empty: 'Nessun sistema di allarme trovato',
      },
      updatedSuccess: 'Sistema di allarme aggiornato con successo',
      createdSuccess: 'Sistema di allarme creato con successo',
      deletedSuccess: 'Sistema di allarme eliminato con successo',
      updateError: "Errore durante l'aggiornamento del sistema di allarme",
      createError: 'Errore durante la creazione del sistema di allarme',
      deleteError: "Errore durante l'eliminazione del sistema di allarme",
      fetchError: 'Errore durante il recupero dei sistemi di allarme',
      fetchLogsError: 'Errore durante il recupero dei registri di allarme',
    },
    enerskyAccess: {
      list: {
        header: 'Registri di accesso Enersky',
        description:
          'Gestisci l’accesso alla condivisione dei dati e lo stato dei contratti dei clienti',
        tableTitle: 'Record di accesso',
        addButton: 'Crea record',
        emptyState: 'Nessun record trovato.',
        searchPlaceholder: 'Cerca record esistenti…',
        backButton: 'Torna ai record',
      },

      columns: {
        vendor: 'Fornitore',
        customer: 'Cliente',
        status: 'Stato',
      },

      validation: {
        missingVendor: 'Il fornitore è obbligatorio.',
        missingFirstName: 'Il nome è obbligatorio.',
        missingLastName: 'Il cognome è obbligatorio.',
        missingEmail: 'È necessario fornire un indirizzo e-mail valido.',
        missingCompanyName:
          'Il nome dell’azienda è obbligatorio per i clienti business.',
        missingOrganizationNumber:
          'Il numero di organizzazione è obbligatorio.',
        missingNationalId: 'Il documento di identità nazionale è obbligatorio.',
      },

      feedback: {
        save: {
          missingInfoTitle: 'Informazioni mancanti',
          missingInfoMessage: 'Compila tutti i campi obbligatori.',
          createSuccessTitle: 'Record creato',
          createSuccessMessage:
            'Record creato ed e-mail del contratto inviata.',
          updateSuccessTitle: 'Aggiornato',
          updateSuccessMessage: 'Dati di contatto aggiornati.',
          errorTitle: 'Errore',
          errorMessage: 'Salvataggio non riuscito.',
          duplicateEndUser: 'Questo cliente esiste già in Enersky.',
        },

        refresh: {
          mpidsTitle: 'Abbonamenti aggiornati',
          mpidsMessage: 'Stati MPID aggiornati.',
          statusTitle: 'Stato aggiornato',
          statusMessage: 'Stato del record e MPID aggiornati.',
          errorTitle: 'Errore',
          errorMessage: 'Aggiornamento dei dati non riuscito.',
        },

        resend: {
          title: 'E-mail inviata',
          message:
            'L’e-mail del contratto è stata inviata nuovamente al cliente.',
          errorTitle: 'Errore',
          errorMessage:
            'Invio nuovamente dell’e-mail del contratto non riuscito.',
        },

        history: {
          title: 'Richiesta di dati storici in coda',
          message: 'Dati inseriti in coda.',
          errorTitle: 'Errore',
          errorMessage: 'Inserimento della lettura in coda non riuscito.',
        },

        delete: {
          successTitle: 'Record eliminato',
          successMessage: 'Il record di accesso Enersky è stato eliminato.',
          errorTitle: 'Errore',
          errorMessage: 'Eliminazione del record non riuscita.',
        },
      },

      editEnerskyAccess: {
        labels: {
          basicInfo: 'Informazioni di base',
          vendor: 'Fornitore',
          firstName: 'Nome',
          lastName: 'Cognome',
          email: 'E-mail',
          companyName: 'Nome dell’azienda',
          privatePerson: 'Privato',
          nationalId: 'Documento di identità nazionale',
          organizationNumber: 'Numero di organizzazione',
          systemInfo: 'Informazioni sul record di accesso Enersky',
          accessUrl: 'URL di accesso',
          requestId: 'ID richiesta',
          errorMessage: 'Messaggio di errore',
          mpidSection: 'Punti di misura (MPID)',
          mpid: 'MPID',
          meterNumber: 'Numero contatore',
          address: 'Indirizzo',
          description: 'Descrizione',
          priceArea: 'Area tariffaria',
          status: 'Stato',
          actions: 'Azioni',
          deleteConfirmMessage: 'Sei sicuro di voler eliminare questo record?',
        },

        buttons: {
          resendLink: 'Invia nuovamente il link',
          refreshSubscriptions: 'Aggiorna abbonamenti',
          readHistoricalData: 'Recupera dati storici',
        },

        status: {
          unknown: 'Stato sconosciuto',
        },
        none: 'Nessuno',
        unknownError: 'Errore sconosciuto',
      },

      status: {
        Pending: 'In attesa',
        'Contract email sent': 'E-mail del contratto inviata',
        'Contract link requested': 'Link del contratto richiesto',
        Completed: 'Completato',
        Error: 'Errore',
        Unknown: 'Stato sconosciuto',
      },
    },

    chirpStackKeys: {
      title: 'File di chiavi importati',
      addButton: 'Importa chiavi',
      columns: {
        fileName: 'Nome file',
        uploadedAt: 'Caricato il',
        importedCount: 'Conteggio importato',
      },
      importFile: 'Importa file di chiavi ChirpStack',
      preview: {
        title: 'Anteprima',
        noRows: 'Nessuna riga di anteprima.',
        close: 'Chiudi',
        cancel: 'Annulla',
        confirm: 'Conferma importazione',
      },
      feedback: {
        loadError: 'Caricamento dei file non riuscito',
        previewError: 'Anteprima non riuscita',
        invalidExcel: 'File Excel non valido.',
        missingFile: 'File originale mancante, seleziona di nuovo',
        importSuccess: 'Importazione riuscita',
        importError: 'Importazione non riuscita',
      },
    },

    icMeterData: 'Dati contatore IC',
    buildingSensorData: 'Dati sensore edificio',
    eosSensorData: 'Dati sensore EOS',
    protocol: 'Protocollo di comunicazione',
  },
  buildings: {
    sidebar: {
      modifyToggle: 'Modifica',
      editBuildingTitle: 'Modifica edificio',
      buildingOverviewTitle: "Panoramica dell'edificio",
      editZoneTitle: 'Modifica zona',
      outdoorTemperatureTitle: 'Temperatura esterna',
      indoorClimateTitle: 'Clima interno',
      buildingTemperature: 'Temperatura edificio',
      floorTemperature: 'Temperatura piano',
      outdoorTempLabel: 'Temp. esterna:',
      electricityPriceLabel: "Prezzo dell'elettricità:",
      energyLabel: 'Etichetta energetica:',
      noData: 'Nessun dato',
      aspaTitle: 'Valore di setpoint ASPA',
      zoneFloors: {
        selectFloorLabel: 'Seleziona piano zona:',
        selectBuildingFloorLabel: 'Seleziona piano edificio:',
        changeFloor: '- Cambia piano -',
        addFloor: 'Aggiungi piano',
        groundFloor: 'Piano terra',
      },
    },
    aspa: {
      title: 'Impostazioni ASPA',
      noPayload: 'Nessun dato ASPA trovato per questo edificio.',
      avgTemp: 'Temperatura media',
      acrossAllZones: 'Su tutte le zone',
      highestZoneTemp: 'Temp. zona più alta',
      peakZoneReading: 'Lettura di zona massima',
      lastUpdated: 'Ultimo aggiornamento',
      payloadsReceived: 'dati ricevuti',
      setpointOverview: 'Panoramica setpoint',
      hourView: 'Vista 24 ore',
      hourOfDay: 'Ora del giorno',
      dailySetpoint: 'Setpoint giornaliero (°C)',
      liveSetpoint: 'Setpoint live (°C)',
      avg: 'Media',
      peak: 'Picco',
      trends: 'Tendenze',
      temperature: 'Temperatura',
      humidity: 'Umidità',
      noTrendData: 'Nessun dato di tendenza.',
      recommendations: 'Raccomandazioni',
      noRecommendations: 'Nessuna raccomandazione trovata.',
      actionKeys: {
        cool: 'Raffreddamento',
        coolingLevel: 'Livello di raffreddamento',
        preCool: 'Pre-raffreddamento',
        heat: 'Riscaldamento',
        heatingLevel: 'Livello di riscaldamento',
        preHeat: 'Pre-riscaldamento',
      },
      items: 'elementi',
      on: 'Attivo',
      off: 'Disattivo',
      samples: 'campioni',
      trendPeriod: 'Ultime 2 ore',
    },
    details: {
      header: "Dettagli dell'edificio",
      form: {
        buildingName: "Nome dell'edificio",
        active: 'Attivo',
        buildingInformation: "Informazioni sull'edificio",
        buildingType: 'Tipo di edificio (standard NS)',
        buildingCategory: 'Categoria di edificio',
        constructionYear: 'Anno di costruzione',
        numberOfFloors: 'Numero di piani',
        netUsableFloorArea: 'Superficie utile netta (m²)',
        gridRegion: 'Regione di rete',
        selectGridRegion: '- Seleziona area -',
        mix: 'Mix CO₂',
        addressAndGps: 'Indirizzo & GPS',
        street: 'Via',
        street2: 'Via 2',
        postCode: 'CAP',
        city: 'Città',
        country: 'Paese',
        latitude: 'Latitudine',
        longitude: 'Longitudine',
        fetchGps: 'Ottieni GPS',
        fillStreetCityError:
          'Compila Via e Città per ottenere le coordinate GPS.',
        requiredAddressFields: 'Da compilare prima del salvataggio: {fields}.',
        searchCountry: 'Cerca paese',
        floorNumber: 'Numero di piano',
        preferredCurrency: 'Valuta preferita',
        climateGoalPercentage: 'Percentuale dell’obiettivo climatico',
        changeModel: 'Cambia modello edificio',
        defaultStartingFloor: 'Piano iniziale',
        startingViewHint:
          'Ruota, sposta e ingrandisci l’anteprima per impostare la vista con cui si apre l’edificio.',
        matrikkelData: {
          title: 'Dati Matrikkel',
          error: 'Impossibile recuperare i dati Matrikkel',
          errorTitle: 'Errore',
          matrikkelId: 'ID Matrikkel',
          cadastralNumber: 'Numero catastale',
          propertyUnitNumber: 'Numero dell’unità immobiliare',
          sectionNumber: 'Numero della sezione',
          unitNumber: 'Unità',
          leaseholdNumber: 'Numero del diritto di locazione',
          municipalityName: 'Nome del comune',
          municipalityNumber: 'Numero del comune',
          success: 'Operazione riuscita',
          successTitle: 'Successo',
          fetchMatrikkelData: 'Recupera i dati Matrikkel',
          buildingNumber: 'Numero dell’edificio',
          errorMissing: 'Campi indirizzo richiesti mancanti',
          errorTooMany: 'Troppi indirizzi trovati',
          errorNotFound: 'Nessun indirizzo trovato',
          unitId: 'ID unità',
          noUnitIdFound:
            "Nessuna unità trovata a questo indirizzo. Verifica l'indirizzo su seeiedom.no e riprova.",
          sectionTitle: 'Bruksenhet',
          sectionsTitle: 'Sezione',
          fetchedFromMatrikkel: 'Recuperato dal matrikkel',
          overrideButton: 'Sostituisci bruksenhet',
          overrideSectionButton: 'Sostituisci sezione',
          addButton: 'Aggiungi bruksenhet',
          addSectionButton: 'Aggiungi sezione',
          manualWarning:
            'Necessario solo se i dati matrikkel sono mancanti o errati.',
          buildingType: 'Tipo di edificio',
        },
      },
      baseline: {
        title: 'Baseline',
        recalcButton: 'Ricalcola baseline',
        confirmRecalculate: 'Sei sicuro di voler ricalcolare la baseline?',
        success: 'Baseline ricalcolata con successo',
        error: 'Impossibile ricalcolare la baseline',
        subscriptions: {
          title: 'Abbonamenti Elhub',
          loading: 'Caricamento abbonamenti…',
          emptyState: 'Nessun abbonamento trovato. Aggiungine uno.',
          actions: {
            unsubscribe: 'Disiscrivi',
            subscribe: 'Iscrivi',
            delete: 'Elimina',
            addPlaceholder: 'Inserisci ID punto di misura',
            status: {
              waitingApproval:
                "In attesa dell'approvazione del cliente in Elhub",
            },
            validation: {
              onlyDigits: "L'ID deve contenere solo cifre",
              exactLength:
                "L'ID deve essere di 18 cifre (es. 707057500042153290)",
              startsWith: "L'ID deve iniziare con 7070575000",
              unique: "L'ID deve essere univoco",
            },
            move: {
              selectTargetBuilding: '- Seleziona edificio target -',
              moveSelected: 'Sposta selezionati',
              instructions:
                'Seleziona gli abbonamenti da spostare (fino a 1 min ciascuno).',
              moveSubscriptions: 'Sposta abbonamenti',
            },
            feedback: {
              subscribeSuccess: 'Richiesta di abbonamento inviata',
              unsubscribeSuccess: 'Disiscrizione riuscita',
              deleteSuccess: 'Abbonamento eliminato',
              subscribeError: 'Errore nella richiesta di abbonamento',
              unsubscribeError: 'Errore nella disiscrizione',
              deleteError: "Impossibile eliminare l'abbonamento",
            },
          },
        },
      },
      report: { title: 'Report' },
    },
    model3d: {
      title: 'Modello 3D',
    },
    zoneEdit: {
      title: 'Impostazioni zona',
      form: {
        zoneName: 'Nome zona',
        floorNumber: 'Piano',
        selectCategory: 'Seleziona categoria',
        isHeated: 'Zona riscaldata',
        displayHint: 'Aspetto della zona nella vista 3D.',
        cardSize: 'Dimensione della scheda',
        zoneColor: 'Colore zona',
        devices: {
          availableDevices: 'Dispositivi disponibili',
          zoneDevices: 'Dispositivi zona',
          noMatches: 'Nessun dispositivo corrisponde alla ricerca',
        },
        deleteButton: 'Elimina zona',
        deleteZoneDescription: 'Rimuove la zona in modo permanente.',
        deleteZoneConfirm: 'Sei sicuro di voler eliminare questa zona?',
        deleteError: 'Impossibile eliminare la zona',
      },
    },
    technicalRoom: {
      titles: 'Locali Tecnici',
      emptyState: 'Nessun locale tecnico trovato.',
      technicalRoomDescription: 'Descrizione del locale tecnico',
      technicalRoomNamePlaceholder: 'Nome del locale tecnico',
      technicalRoomDevices: 'Dispositivi nel locale tecnico',
      addDevice: 'Aggiungi dispositivo',
      technicalRoomDevice: 'Dispositivo del locale tecnico',
      removeDevice: 'Rimuovi',
      searchPlaceholder: 'Cerca locale tecnico',
      technicalRoomOverview: 'Panoramica locale tecnico',
      technicalRoomValue: 'Valore',
      technicalRoomSeen: 'Ultimo accesso',
      addTechnicalRoom: 'Aggiungi locale tecnico',
      addDeviceButton: 'Aggiungi dispositivo',
      removeDeviceButton: 'Rimuovi dispositivo',
      deviceType: 'Tipo di dispositivo',
      editorTitle: 'Locali tecnici',
      selectRoom: 'Seleziona un locale tecnico',
      threeDModel: 'Modello 3D',
      replace: 'Sostituisci',
      selectModel: 'Seleziona un modello 3D',
      modelDefaultsGroup: 'Modelli predefiniti',
      noModel: 'Nessun modello 3D associato a questo locale.',
      bind: 'Collega',
      rebind: 'Ricollega',
      unbind: 'Scollega',
      boundTo: 'Collegato a',
      notBound: 'Non collegato',
      hide: 'Nascondi in 3D',
      show: 'Mostra in 3D',
      size: 'Dimensione',
      remove: 'Rimuovi dal locale',
      pickingHint: 'Clicca il modello per collegare',
      pickingCardHint:
        'Clicca una parte del modello, o lo sfondo per posizionare la scheda liberamente',
      searchDevices: 'Cerca dispositivi…',
      noDevicesAvailable: 'Nessun dispositivo disponibile',
      noMatches: 'Nessun risultato',
      unnamedDevice: 'Dispositivo senza nome',
      couldNotAddDevice: 'Impossibile aggiungere il dispositivo',
      noReadings24h: 'Nessuna lettura nelle ultime 24 ore',
      dragToReposition: 'Trascina per riposizionare',
      hideGraph: 'Nascondi grafico',
      showGraph: 'Mostra grafico',
      lockedHint: 'Sblocca la vista per spostare i dispositivi',
      clickToEdit: 'Clicca per modificare',
      noDescription: 'Nessuna descrizione',
      noTitle: 'Nessun titolo',
      showCardTitle: 'Titolo della scheda',
      showDeviceName: 'Nome del dispositivo',
      cardVisualization: 'Visualizzazione della scheda',
      modelAnimation: 'Animazione del modello',
      showLine: 'Linea di collegamento',
      lineColor: 'Colore della linea',
      resetColor: 'Ripristina colore',
      darkTheme: 'Tema scuro',
      showUnit: 'Unità',
      trendLine: 'Linea di tendenza',
      trendBars: 'Barre di tendenza',
      showUpdated: 'Ultimo aggiornamento',
      visualizationRules: 'Regole di visualizzazione',
      ruleDataKey: 'Chiave dati',
      ruleValue: 'Valore',
      triggers: 'Trigger',
      addTrigger: 'Aggiungi trigger',
      ruleOff: 'Off',
      ruleSlow: 'Lento',
      ruleFast: 'Veloce',
      ruleNoEffect: 'Nessun effetto',
      ruleNoColor: 'Nessun colore',
      ruleReverse: 'Inverti direzione',
      particleFlow: 'Flusso di particelle',
      drawFlow: 'Disegna flusso',
      flowHint: 'Fai clic sul modello per aggiungere punti.',
      flowFollowsHint:
        "Le particelle seguono i trigger dell'animazione del modello. Quando l'animazione è spenta, le particelle si fermano.",
      flowColorHint:
        'Fai clic su un punto del flusso nel modello per cambiarne il colore da lì in poi.',
      flowColorFromPoint: 'Colore dal punto selezionato',
      flowFollows: "Segue l'animazione",
      particles: 'Particelle',
      ruleDataKeyRequired:
        'Seleziona una chiave dati per la regola di visualizzazione',
      newTechnicalRoom: 'Nuovo locale tecnico',
      roomNamePlaceholder:
        'es. Ventilazione, Centrale termica, Pompa di calore',
      selectBuilding: 'Seleziona un edificio',
      nameRequired: 'Il nome è obbligatorio',
      buildingRequired: 'L’edificio è obbligatorio',
      couldNotCreateRoom: 'Impossibile creare il locale',
      creating: 'Creazione in corso',
      loadError: 'Impossibile caricare il locale tecnico',
      textPlaceholder: 'Scrivi il testo…',
      noText: 'Nessun testo',
      linkToRoom: 'Vai alla sala',
      noLink: 'Nessun link',
      linkHint:
        'Nella vista bloccata un clic sul modello o sulla scheda apre questa sala.',
      confirmRemoveAnnotation:
        'Vuoi davvero rimuovere questo testo dalla sala?',
      dragToReorder: 'Trascina per riordinare',
      drawFrame: 'Disegna riquadro',
      redrawFrame: 'Ridisegna riquadro',
      frameDrawHint: 'Clicca due angoli del disegno',
      noFrame: 'Nessun riquadro disegnato',
      frameDrawn: 'Riquadro disegnato',
      confirmRemoveFrame: 'Vuoi davvero rimuovere questo riquadro dalla sala?',
      confirmRemoveLink: 'Vuoi davvero rimuovere questo link dalla sala?',
      annotationsTab: 'Link e testo',
      noAnnotations: 'Nessun link o testo in questa sala.',
      placeText: 'Posiziona',
      replaceText: 'Posiziona di nuovo',
      placed: 'Posizionato',
      placeTextHint: 'Clicca sul disegno dove deve stare il testo',
      placeInfoHint: 'Clicca sul disegno dove deve stare la bolla',
      confirmRemoveInfo:
        'Vuoi davvero rimuovere questa bolla informativa dalla sala?',
      ruleAngle: 'Angolo (gradi)',
      infoPanel: 'Allarmi e calendario operativo',
      alarmsTab: 'Allarmi',
      calendarsTab: 'Calendario operativo',
      noAlarmSystems: 'Nessun sistema di allarme è collegato a questa sala.',
      noCalendars: 'Nessun calendario operativo è collegato a questa sala.',
      systemAlarm: 'Allarme di sistema',
      openInSettings: 'Apri nelle impostazioni',
      confirmRemoveDevice:
        'Sei sicuro di voler rimuovere questo dispositivo dal locale?',
      attributes: 'Attributi',
      selectAttribute: 'Seleziona un attributo',
      mappedGroup: 'Attributi mappati',
      payloadGroup: 'Dati grezzi',
      mappedNoneText: 'Nessuno disponibile,',
      assignHere: 'assegna qui',
      confirmDeleteRoom: 'Sei sicuro di voler eliminare {name}?',
      roomDeleted: 'Locale tecnico eliminato',
      renameRoom: 'Rinomina locale tecnico',
      noTechnicalRoomsForType: 'Nessun locale tecnico di questo tipo trovato',
      noDevices: 'Nessun dispositivo in questo locale tecnico.',
      technicalRoomTypeLabel: 'Tipo di locale tecnico',
      technicalRoomTypes: {
        type: 'Seleziona tipo',
        hvac: 'HVAC',
        technical: 'Locale tecnico',
        electrical: 'Elettrico',
        plumbing: 'Idraulico',
        other: 'Altro',
      },
      message: {
        success: 'Locale tecnico creato con successo',
        updateSuccess: 'Locale tecnico aggiornato con successo',
        deleteSuccess: 'Locale tecnico eliminato con successo',
        error:
          "Si è verificato un errore durante l'elaborazione della richiesta",
        deleteConfirm: 'Sei sicuro di voler eliminare questo locale tecnico?',
      },
    },
  },
  threeD: {
    lockView: 'Blocca vista',
    unlockView: 'Sblocca vista',
  },

  buildings3D: {
    header: {
      buildingTab: 'Edificio',
      technicalTab: 'Tecnico',
    },
    footer: {
      home: 'Home',
      measure: 'Misura',
      stopMeasure: 'Ferma misura',
      explode: 'Esplodi',
      screenshot: 'Screenshot',
      lock: 'Blocca',
      unlock: 'Sblocca',
    },
    climate: {
      buildingClimate: 'Climat intérieur',
      levelsTitle: 'Sections',
      startLabel: 'Début',
      endLabel: 'Fin',
      apply: 'Appliquer',
      avgTemperature: 'Température moyenne',
      avgHumidity: 'Humidité moyenne',
      avgCo2: 'CO₂ moyen',
      floor: 'Étage',
      wholeBuilding: 'Intero edificio',
      noTrendData: 'Aucune donnée',
      fetchData: 'Récupérer les données',
      startMustBeBeforeEnd: 'Le début doit être avant la fin.',
      groundFloor: 'Rez-de-chaussée',
      weekdaysShort: ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'],
    },
    status: {
      good: 'Bon',
      tooLow: 'Trop bas',
      tooHigh: 'Trop élevé',
      warning: 'Avertissement',
      poor: 'Mauvais',
    },
    warnings: {
      title: 'Avvisi',
      highCo2: 'CO₂ elevata',
      highTemp: 'Temperatura alta',
      lowTemp: 'Temperatura bassa',
    },
    alarmLog: {
      title: 'Registro allarmi',
      last24h: 'Ultime 24 ore',
      last7d: 'Ultimi 7 giorni',
      last30d: 'Ultimi 30 giorni',
      custom: 'Personalizzato',
      zone: 'Zona',
      activeNow: 'Attivi ora',
      today: 'Oggi',
      yesterday: 'Ieri',
      earlier: 'Prima',
      empty: 'Nessun allarme in questo intervallo',
      loadError: 'Impossibile caricare il registro allarmi.',
      unknownZone: 'Zona sconosciuta',
    },
    deviceLayer: {
      moveDevices: 'Sposta modelli',
      moveHint: 'Trascina per spostare · ⇧ ruota · ⌘ altezza',
      moveThisDevice: 'Sposta questo dispositivo',
      doneMoving: 'Fine spostamento',
      changeModel: 'Cambia modello',
      showDataBox: 'Mostra riquadro dati',
      hideDataBox: 'Nascondi riquadro dati',
      modelSize: 'Dimensione modello',
      dataSize: 'Dimensione dati',
      hideZones: 'Nascondi zone',
      showZones: 'Mostra zone',
      hideModels: 'Nascondi modelli',
      showModels: 'Mostra modelli',
      hideModel: 'Nascondi modello',
      showModel: 'Mostra modello',
      suggested: 'Suggerito',
      noModelsInCategory: 'Nessun modello in questa categoria per ora',
      controllers: 'Controller',
      models: {
        radiatorGlb: 'Radiatore',
        panelOvenGlb: 'Pannello radiante',
        heatpumpGlb: 'Pompa di calore',
        indoorClimateGlb: 'Clima interno',
        icmSensorGlb: 'Sensore ICM',
        climateHubGlb: 'Hub climatico',
        ventilationOutletGlb: 'Bocchetta di ventilazione',
        ventilationGrillGlb: 'Griglia di ventilazione',
      },
    },
    zoneControls: {
      leaveFloor: 'Esci',
      drawZone: 'Doppio clic per terminare',
      clearZones: 'Cancella zone',
      clickFloorToIsolate: 'Clicca sul piano per isolare',
      select: 'Seleziona',
      rectangle: 'Rettangolo',
      circle: 'Cerchio',
      polygon: 'Poligono',
      zoneNameLabel: 'Nome zona',
      heightLabel: 'Altezza',
      editVertexHint:
        'Trascina i punti per modificare, doppio clic per aggiungerne',
      unnamedZone: 'Zona senza nome',
      zoneNameRequired: 'Il nome della zona è obbligatorio',
      zonesMissingData: 'Zone senza dati 3D',
      zonesMissingDataTitle: 'Zone senza dati del modello 3D:',
      floorLabel: 'Piano',
      zoneCreated: 'Zona creata',
      zoneUpdated: 'Zona aggiornata',
      zoneDeleted: 'Zona eliminata',
      failedToCreateZone: 'Impossibile creare la zona',
      failedToUpdateZone: 'Impossibile aggiornare la zona',
      failedToDeleteZone: 'Impossibile eliminare la zona',
      confirmDeleteZoneTitle: 'Eliminare la zona?',
      confirmDeleteZoneMessage:
        "Sei sicuro di voler eliminare questa zona? L'azione non può essere annullata.",
    },
  },

  deviceAlarms: {
    updatedSuccess: 'Allarme dispositivo aggiornato con successo',
    createdSuccess: 'Allarme dispositivo creato con successo',
    deletedSuccess: 'Allarme dispositivo eliminato con successo',

    editTitle: 'Modifica allarme dispositivo',
    createTitle: 'Crea allarme dispositivo',
    title: 'Allarmi dispositivo',
    manageAlarmsForDevice: 'Gestisci allarmi per {device}',
    recipients: 'Elenco destinatari',

    alarmDetails: "Dettagli dell'allarme",
    deviceSelection: 'Selezione dispositivo',
    alarmConditions: "Condizioni dell'allarme",
    condition: 'Condizione',
    conditions: 'Condizioni',
    noConditions: 'Nessuna condizione aggiunta.',
    noConditionsSaveError: 'È richiesta almeno una condizione',

    name: 'Nome',
    description: 'Descrizione',
    alarmSystem: 'Sistema di allarme',
    selectDevice: 'Seleziona dispositivo',
    dataKey: 'Chiave dati',
    selectKey: 'Seleziona chiave',
    level: 'Livello',
    operator: 'Operatore',
    value: 'Valore',
    duration: 'Durata (min)',
    message: 'Messaggio',
    active: 'Attivo',

    greaterThan: 'Maggiore di',
    lessThan: 'Minore di',
    equal: 'Uguale',
    notEqual: 'Diverso',
    missing: 'Mancante',
    unchanged: 'Invariato',

    addTrigger: 'Aggiungi trigger',
    addCondition: 'Aggiungi condizione',
    triggers: 'Trigger',

    standardDevices: 'Dispositivi standard',
    eosDevices: 'Dispositivi EOS',
    noDataKeys: 'Nessuna chiave dati disponibile per questo dispositivo.',

    noAlarmSystems: 'Nessun sistema di allarme disponibile.',
    pleaseCreateFirst: 'Si prega di crearne uno prima',
    selectDeviceFirst:
      "Seleziona prima un dispositivo per configurare le condizioni dell'allarme.",
    messagePlaceholder: 'Messaggio di avviso da visualizzare...',
    confirmDelete: 'Sei sicuro di voler eliminare questo allarme dispositivo?',
    list: {
      new: 'Nuovo',
      search: 'Cerca...',
      empty: 'Nessun allarme dispositivo trovato',
    },
    deleteAlarmTitle: 'Elimina allarme',
    deleteAlarmDescription: 'Questa azione non può essere annullata.',
  },

  settings: {
    /* ----------------------------- NAV AREAS ---------------------------- */
    areas: {
      home: 'Home',
      vendor: 'Generale',
      devices: 'Dispositivi',
      eos_devices: 'Dispositivi EOS',
      categories: 'Categorie',
      users: 'Utenti',
      themes: 'Temi',
      integrationOverview: 'Integrazioni API',
      fileCloud: 'File Cloud',
      energyPrices: "Prezzi dell'energia",
      alarms: 'Allarmi',
      alarmSystemDescription:
        'Gestisci e personalizza i sistemi di allarme con notifiche su misura e monitoraggio del battito cardiaco per rimanere informato sugli eventi critici e garantire risposte tempestive.',
      baseline: 'Linea di base',
      technicalRoomOverview: 'Locali tecnici',
      aspaSetup: 'Configurazione ASPA',
      controlStrategy: 'Strategia di controllo',
      operatingCalendar: 'Calendari operativi',
      setpoint: 'Setpoint',
    },
    home: {
      title: 'Dashboard aziendale',
      tagline:
        'Gestisci impostazioni, utenti, dispositivi e temi della tua azienda in un unico posto',
    },

    dashboardItems: {
      themes: {
        title: 'Temi',
        description: 'Crea e gestisci i temi colore della tua applicazione',
        linkText: 'Vedi temi',
      },
      users: {
        title: 'Utenti',
        description: 'Gestisci account utente e permessi',
        linkText: 'Vedi utenti',
      },
      eosDevices: {
        title: 'Dispositivi EOS',
        description: 'Monitora e gestisci i sensori di monitoraggio energia',
        linkText: 'Vedi dispositivi EOS',
      },
      settings: {
        title: 'Impostazioni',
        description: 'Configura le impostazioni globali dell’applicazione',
        linkText: 'Vedi impostazioni',
      },
      devices: {
        title: 'Dispositivi',
        description: 'Configura e monitora i dispositivi connessi',
        linkText: 'Vedi dispositivi',
      },
      fileCloud: {
        title: 'File Cloud',
        description:
          'Archivia, organizza e condividi file in tutta l’organizzazione',
        linkText: 'Vedi file',
      },
      integration: {
        title: 'Integrazioni API',
        description: 'Configura e gestisci connessioni e integrazioni API',
        linkText: 'Vedi integrazioni',
      },
      categories: {
        title: 'Categorie',
        description: 'Crea e gestisci le categorie dei dispositivi',
        linkText: 'Vedi categorie',
      },
    },

    aspaSetup: {
      list: {
        header: 'Configurazione ASPA',
        addButton: 'Aggiungi configurazione ASPA',
        emptyState: 'Nessuna configurazione ASPA trovata.',
        searchPlaceholder: 'Cerca...',
      },
      edit: {
        name: 'Nome configurazione ASPA',
        units: 'Unità',
        addUnit: 'Aggiungi unità',
        unitName: "Nome dell'unità",
        setpoints: 'Setpoint',
        zones: 'Zone',
        removeUnit: 'Rimuovi unità',
        copyMondayToWeekdays: 'Copia lunedì ai giorni feriali',
        copyMondayToAllDays: 'Copia lunedì a tutti i giorni',
      },
      feedback: {
        deleteSuccess: 'Configurazione ASPA eliminata con successo',
        deleteError:
          "Si è verificato un errore durante l'eliminazione della configurazione ASPA",
        updateSuccess: 'Configurazione ASPA aggiornata con successo',
        updateError:
          "Si è verificato un errore durante l'aggiornamento della configurazione ASPA",
        createSuccess: 'Configurazione ASPA creata con successo',
        createError:
          'Si è verificato un errore durante la creazione della configurazione ASPA',
        saveError:
          'Si è verificato un errore durante il salvataggio della configurazione ASPA',
      },
    },

    energyPrices: {
      list: {
        add: 'Aggiungi prezzo energia',
        header: 'Impostazioni prezzi energia',
        emptyState: 'Nessuna impostazione dei prezzi energia trovata.',
        searchPlaceholder: 'Cerca impostazioni prezzi energia...',
      },

      name: 'Nome',
      notes: 'Note',
      building: 'Edificio',
      selectBuilding: 'Seleziona edificio',
      validFrom: 'Valido dal',
      validTo: 'Valido fino al',
      ongoing: 'In corso',
      notSpecified: 'Non specificato',

      electricityDetails: 'Dettagli elettricità',
      priceModel: 'Modello tariffario',
      fixed: 'Prezzo fisso',
      spotMarkup: 'Spot + maggiorazione',
      fixedPricePerKWh: 'Prezzo fisso per kWh',
      spotMarkupPerKWh: 'Maggiorazione per kWh',

      supplierMonthlyFee: 'Canone mensile del fornitore',
      co2Emissions: 'Emissioni di CO₂ (gCO₂/kWh)',

      gridTariffs: 'Oneri di rete',
      gridTariff: 'Onere di rete',
      fixedMonthly: 'Canone mensile fisso',
      energyPerKWh: 'Energia per kWh',
      demandPerKWMonthly: 'Quota potenza per kW al mese',
      consumptionTaxPerKWh: 'Imposta sui consumi per kWh',

      energySources: 'Fonti energetiche',
      addEnergySources: 'Aggiungi fonti energetiche',
      energySource: 'Informazioni sulla fonte energetica',
      sourceName: 'Nome della fonte',
      electricity: 'Elettricità fornita',
      electricityPrice: 'Prezzo dell’elettricità',
      electricityProduced: 'Elettricità prodotta',
      electricityExported: 'Elettricità esportata',

      districtHeating: 'Teleriscaldamento',
      districtHeatingSource: 'Fonte energetica del teleriscaldamento',
      districtHeatingPrice: 'Prezzo del teleriscaldamento',
      districtHeatingEnergyPrice: 'Prezzo energia (kr/kWh)',
      districtHeatingDemandPerKWMonthly:
        'Potenza massima misurata (kr/kW/mese)',

      fuelSources: 'Fonti di combustibile',
      fuelSource: 'Informazioni sulla fonte di combustibile',
      fuelType: 'Fonte energetica',

      propane: 'Propano',
      fuelOilDiesel: 'Olio combustibile / Diesel',
      lng: 'Gas naturale (LNG)',
      kerosene: 'Cherosene',
      pelletsBricks: 'Pellet / Bricchette',
      biodiesel: 'Biodiesel',
      biogas: 'Biogas',
      other: 'Altro',

      consumptionUnit: 'Unità di consumo',
      kg: 'kg',
      liter: 'litro',
      unitPrice: 'Prezzo unitario',
      consumption: 'Consumo',
      conversionFactorToKWh: 'Fattore di conversione in kWh',

      periodLabel: 'Periodo',
      periodLabelPlural: 'Periodi',
      periodName: 'Nome del periodo',
      addPeriod: 'Aggiungi periodo',
      removePeriod: 'Rimuovi periodo',
      removePeriodConfirmation: 'Sei sicuro di voler rimuovere questo periodo?',
      noPeriodsDefined: 'Nessun periodo.',
      overlappingPeriodsError:
        'I periodi "{p1}" e "{p2}" si sovrappongono.\n\n' +
        'Non è possibile avere due periodi validi contemporaneamente (stessi mesi e orari sovrapposti). ' +
        'Modifica i mesi o le ore attive prima di salvare.',
      confirmRemovePeriod: 'Sei sicuro di voler rimuovere il periodo?',
      mixedMonthsError:
        'Non è possibile combinare mesi specifici con "tutti i mesi" (mesi vuoti) tra i periodi.\n\n' +
        'Questi periodi devono selezionare i mesi: {periods}\n\n' +
        'Suggerimento: seleziona i mesi per tutti i periodi oppure lascia i mesi vuoti per tutti.',

      generalInformation: 'Informazioni generali',
      activeMonths: 'Mesi attivi (tutti se vuoto)',
      activeBetween: 'Orari attivi (tutto il giorno se vuoto)',
      chosenMonths: 'Mesi attivi',
      activeHours: 'Orari attivi',
      allYear: 'Tutto l’anno',
      allDay: 'Tutto il giorno',
      addAdditionalTimer: 'Aggiungi un altro intervallo di tempo',
      startTime: 'Ora di inizio ',
      endTime: 'Ora di fine ',
      timeRangeInvalid:
        'L’orario di fine deve essere successivo a quello di inizio',
      timeRangesOverlap: 'Gli intervalli di tempo non possono sovrapporsi',
      timeRangeEqual: 'L’orario di inizio e di fine non possono essere uguali',

      co2Source: 'Tipo di energia del teleriscaldamento',
      co2Array: [
        'Elettricità',
        'Rifiuti',
        'Olio combustibile leggero',
        'Olio combustibile pesante',
        'GPL',
        'Gas naturale (LNG)',
        'Biomassa legno primaria',
        'Biomassa legno secondaria',
        'Cippato RT',
        'Pellet, bricchette e polvere',
        'Bio-olio',
        'Pompa di calore',
      ],

      fixedFees: 'Costi fissi',
      substationFee: 'Costo sottostazione (al mese)',
      reactiveEffect: 'Costo per energia reattiva',
      connectedDevices: 'Dispositivi connessi',
      noConnectedDevices: 'Nessun dispositivo connesso',
      deletedDevice: 'Eliminato',
      removeSource: 'Rimuovi fonte',
      noLinkedDevices: 'Nessun dispositivo collegato',
      linked: 'Dispositivi collegati',
      unlinkDeviceMessage: 'Sei sicuro di voler rimuovere questo dispositivo?',

      linkSourceTitle: 'Collega la fonte a un dispositivo EOS',
      linkSource: 'Collega la fonte ai dispositivi EOS',
      linkSourceDescription:
        'Seleziona i dispositivi EOS collegati a questa fonte energetica.',

      removeElectricitySourceConfirmation:
        'Sei sicuro di voler rimuovere la fonte elettrica ',
      removeDistrictHeatingSourceConfirmation:
        'Sei sicuro di voler rimuovere la fonte del teleriscaldamento ',
      removeFuelSourceConfirmation:
        'Sei sicuro di voler rimuovere la fonte di combustibile ',
    },

    setpoint: {
      title: 'Setpoint',
      backToList: 'Tutti i setpoint',
      description: 'Limiti di temperatura, umidità e CO₂ per edificio e zona.',
      searchPlaceholder: 'Cerca setpoint …',
      emptyState: 'Nessun setpoint ancora.',
      addButton: 'Nuovo setpoint',
      loadError: 'Impossibile caricare i setpoint.',
      zonesLoadError: 'Impossibile caricare le zone.',
      saveError: 'Impossibile salvare il setpoint.',
      deleteError: 'Impossibile eliminare il setpoint.',
      requiredError: 'Questi campi sono obbligatori:',
      deleteConfirmTitle: 'Elimina setpoint',
      deleteConfirmMessage:
        'Vuoi davvero eliminare questo setpoint? L’operazione non può essere annullata.',
      editTitle: 'Modifica setpoint',
      newTitle: 'Nuovo setpoint',
      editDescription: 'I limiti si applicano alle zone selezionate.',
      saveButton: 'Salva setpoint',
      openSetpoint: 'Apri il setpoint',
      buildingSection: 'Edificio',
      building: 'Edificio',
      name: 'Nome',
      namePlaceholder: 'Es. Ufficio standard',
      zonesSection: 'Zone',
      selectAll: 'Seleziona tutto',
      clearAll: 'Deseleziona tutto',
      noZones: 'Scegli un edificio per vedere le sue zone.',
      allZonesTaken: 'Tutte le zone di questo edificio hanno già un setpoint.',
      zonesTakenError: 'Una o più zone appartengono già a un altro setpoint.',
      noZonesSelected: 'Nessuna zona selezionata',
      floor: 'Piano',
      noFloor: '—',
      limitsSection: 'Limiti',
      columns: {
        name: 'Nome',
        building: 'Edificio',
        zones: 'Zone',
        inOperation: 'In esercizio',
        outsideOperation: 'Fuori esercizio',
        interval: 'Intervallo di controllo',
      },
    },
    operatingCalendar: {
      backToList: 'Tutti i calendari',
      title: 'Calendari operativi',
      description:
        'Orari operativi normali per edificio e zona, con esercizio straordinario sopra.',
      searchPlaceholder: 'Cerca tra i calendari …',
      emptyState: 'Nessun calendario operativo.',
      addButton: 'Nuovo calendario operativo',
      running: 'In corso, senza data di fine',
      openCalendar: 'Apri il calendario',
      zonesLoadError: 'Impossibile caricare le zone.',
      loadError: 'Impossibile caricare i calendari operativi.',
      saveError: 'Impossibile salvare il calendario operativo.',
      deleteError: 'Impossibile eliminare il calendario operativo.',
      requiredError: 'Questi campi sono obbligatori:',
      deleteConfirmTitle: 'Elimina calendario operativo',
      deleteConfirmMessage:
        'Vuoi davvero eliminare questo calendario operativo? L’operazione non è reversibile.',
      editTitle: 'Imposta esercizio normale',
      editDescription: 'Orari settimanali fissi per le zone selezionate.',
      saveButton: 'Salva esercizio normale',
      buildingSection: 'Edificio',
      building: 'Edificio',
      zonesSection: 'Zone',
      selectAll: 'Seleziona tutto',
      clearAll: 'Deseleziona tutto',
      noZonesSelected: 'Nessuna zona selezionata',
      zonesTakenError:
        'Una o più zone appartengono già a un altro calendario operativo.',
      allZonesTaken:
        'Tutte le zone di questo edificio appartengono già a un calendario.',
      noZones: 'Scegli un edificio per vedere le zone.',
      floor: 'Piano',
      noFloor: 'Senza piano',
      validitySection: 'Nome e validità',
      name: 'Nome',
      validFrom: 'Valido dal',
      validTo: 'Valido fino al',
      weekPlanSection: 'Piano settimanale',
      copyMonday: 'Copia lunedì su tutti i feriali',
      noOperation: 'Nessun esercizio',
      weeklyTotal: 'Totale settimanale',
      from: 'Da',
      to: 'A',
      calendarTitle: 'Calendario operativo',
      week: 'Settimana',
      previousWeek: 'Settimana precedente',
      nextWeek: 'Settimana successiva',
      today: 'Oggi',
      editNormal: 'Esercizio normale',
      addOverride: 'Aggiungi esercizio straordinario',
      thisWeek: 'Questa settimana',
      operatingHours: 'Ore di esercizio',
      extraordinaryDays: 'Giorni straordinari',
      upcomingOverrides: 'Prossimo esercizio straordinario',
      noOverrides: 'Nulla in programma.',
      fixedOperation: 'Esercizio fisso',
      publicHoliday: 'Giorno festivo',
      extraordinary: 'Esercizio straordinario',
      closed: 'Chiuso',
      opensAt: 'Apre',
      closesAt: 'Chiude',
      inOperation: 'In esercizio',
      outOfOperation: 'Fuori esercizio',
      allDay: 'Tutto il giorno',
      reason: 'Motivo',
      overrideSaveError: 'Impossibile salvare l’esercizio straordinario.',
      overrideDeleteError: 'Impossibile eliminare.',
      columns: {
        name: 'Nome',
        building: 'Edificio',
        zones: 'Zone',
        validity: 'Validità',
        hoursPerWeek: 'Ore/sett.',
      },
      weekdays: {
        mon: 'Lun',
        tue: 'Mar',
        wed: 'Mer',
        thu: 'Gio',
        fri: 'Ven',
        sat: 'Sab',
        sun: 'Dom',
      },
    },
    controlStrategy: {
      list: {
        header: 'Strategie di controllo',
        addButton: 'Aggiungi strategia',
        emptyState: 'Nessuna strategia di controllo trovata.',
        searchPlaceholder: 'Cerca per edificio...',
      },
      feedback: {
        saveSuccess: 'Strategia di controllo salvata',
        saveError: 'Errore durante il salvataggio della strategia',
        buildingRequired: "L'edificio è obbligatorio",
        bothHoursRequired:
          "Sia l'ora di inizio che di fine devono essere impostate",
        startBeforeEnd:
          "L'ora di inizio deve essere precedente all'ora di fine",
        deleteSuccess: 'Strategia di controllo eliminata',
        deleteError: "Errore durante l'eliminazione della strategia",
        confirmDeleteTitle: 'Elimina strategia di controllo',
        confirmDeleteMessage:
          'Sei sicuro di voler eliminare questa strategia di controllo? Questa azione non può essere annullata.',
      },
      schedule: 'Orario operativo',
      timezone: 'Fuso orario',
      startHour: 'Orario operativo inizio',
      endHour: 'Orario operativo fine',
      actions: 'Azioni',
      coolingLevel: 'Livello di raffreddamento',
      heatingLevel: 'Livello di riscaldamento',
      businessHoursControl: "Controllo durante l'orario lavorativo",
      afterHoursControl: 'Controllo fuori orario lavorativo',
      controlOutsideBusinessHours: 'Controlla fuori orario lavorativo',
      tempMin: 'Temp min (°C)',
      tempMax: 'Temp max (°C)',
      co2Min: 'CO₂ min (ppm)',
      co2Max: 'CO₂ max (ppm)',
      actionLabels: {
        cool: 'Raffredda',
        heat: 'Riscalda',
        preCool: 'Pre-raffredda',
        preHeat: 'Pre-riscalda',
        ventilate: 'Ventila',
        dehumidify: 'Deumidifica',
      },
      closed: 'Chiuso',
      afterHoursActions: 'Azioni fuori orario',
    },

    baseline: {
      updated: 'Aggiornato',
      title: 'Baseline',
      searchPlaceholder: 'Cerca baseline...',
      addButtonLabel: 'Crea nuova baseline',
      confirmDeleteTitle: 'Elimina baseline',
      confirmDeleteMessage: 'Sei sicuro di voler eliminare questa baseline?',
      noBaselines: 'Nessuna baseline trovata. Crea una nuova baseline.',
      createNewBaselineConfirm:
        'Creare una nuova baseline? Questa sovrascriverà quella esistente.',
      editBaseline: 'Modifica baseline per',
      calculateBaseline: 'Calcola baseline',
      baselineChart: 'Grafico baseline',
      monthsCovered: 'Mesi inclusi',
      excludeMonths: 'Escludi mesi',
      pendingChanges:
        'Modifiche non salvate. Clicca su Salva per aggiornare la baseline.',
      clickMonthsToExclude: `Fai clic sui mesi per escluderli dalla linea di base. I mesi in arancione presentano una deviazione del 20% o superiore rispetto alla linea di base.`,
      year: 'Anno',
      month: 'Mese',
      energyType: 'Tipo di energia',
      monthlySummary: 'Riepilogo mensile',
      weeklySummary: 'Riepilogo settimanale',
      week: 'Settimana',
      summary: 'Riepilogo',
      excluded: 'Escluso dalla baseline',
      energyTypes: {
        electricity: 'Elettricità',
        districtHeating: 'Teleriscaldamento',
        fuel: 'Combustibile',
      },
      overBaseline: 'Sopra la baseline',
      underBaseline: 'Sotto la baseline',
      included: 'Incluso nella baseline',
      activeLabel: 'Attivo',
      inactiveLabel: 'Inattivo',
      createdAt: 'Creato il',
      lockTooltip: {
        locked: 'Bloccata — clicca per consentire modifiche',
        unlocked: 'Blocca per impedire modifiche',
      },
      description: 'Crea e configura le baseline',
      backButtonLabel: 'Torna alle baseline',
    },

    topics: {
      addButton: '+ Aggiungi argomento',
      eosName: 'Nome EOS',
      sensorTag: 'Tag sensore',
      sensorTagRequired: 'Il tag sensore è obbligatorio',
      sensorTagTooShort: 'Il tag sensore deve avere almeno 3 caratteri',
      assignedTo: 'Usato da',
      aggregator: {
        title: 'Aggregatore',
        sum: 'Somma',
        average: 'Media',
        max: 'Max',
        min: 'Min',
        cumulative: 'Cumulativo',
        differential: 'Differenziale',
        last: 'Ultimo',
      },
      scale: 'Scala',
      decimals: 'Decimali',
      units: 'Unità',
      removeButton: 'Rimuovi',
      deleteTopic: 'Elimina argomento',
      confirmDelete: 'Sei sicuro di voler eliminare questo argomento?',
    },

    /* --------------------------- DEVICE LIST ---------------------------- */
    devices: {
      installNetmoreButton: 'Installa dispositivo Netmore',
      gatewayInstaller: 'Installatore gateway Netmore',
      gatewayEUI: 'Gateway EUI',
      installChirpStackButton: 'Installa dispositivo ChirpStack',
      serialNumber: 'Numero di serie',
      bulkSerialsLabel: 'Numeri di serie (separati da virgola o nuova riga)',
      ui: {
        singleModeTitle: 'Dispositivo singolo',
        bulkModeTitle: 'Installazione multipla',
        bulkNameHintLine1:
          'Nome vuoto -> i numeri di serie vengono usati come nomi',
        bulkNameHintLine2:
          'Nome impostato -> tutti i dispositivi usano lo stesso nome',
      },
      visualToggle: {
        visualToggleDevice: 'Dispositivo Visual Toggle',
        visualToggleBuilding: 'Edificio',
        visualToggleDelimiter: 'Delimitatore',
        visualToggleDataKey: 'Chiave dati',
        visualToggleProperty: 'Proprietà',
        visualTogglePropertyId: 'ID proprietà',
        visualToggleValue: 'Valore',
        visualToggleColor: 'Colore',
        visualToggleTriggers: 'Trigger',
        visualToggleAddTrigger: 'Aggiungi Trigger',
        visualToggleRemove: 'Rimuovi Trigger',
        visualToggleSelectBuilding: 'Seleziona Edificio',
        visualToggleSelectValue: 'Seleziona Valore',
        visualToggleDev: 'Dispositivo',
        visualToggleOverview: 'Panoramica Dispositivo Visual Toggle',
        visualToggleAdd: 'Aggiungi Dispositivo Visual Toggle',
        visualToggleGlobalModels: 'Modelli 3D globali',
        visualToggleDelete: 'Elimina Dispositivo Visual Toggle',
        visualToggleNoDevices: 'Nessun dispositivo Visual Toggle trovato.',
        visualToggleSearchPlaceholder: 'Cerca dispositivi Visual Toggle...',
        visualToggleName: 'Nome',
        visualToggleTechnicalRoom: 'Locale tecnico',
        visualToggleSelectRoom: 'Seleziona un locale tecnico',
        visualToggleBuildingRequired: 'L’edificio è obbligatorio',
        visualToggleTechnicalRoomRequired: 'Il locale tecnico è obbligatorio',
        visualToggleDeviceRequired: 'Il dispositivo è obbligatorio',
        visualtoggleAxes: {
          xAxis: 'Rotation X',
          yAxis: 'Rotation Y',
          zAxis: 'Rotation Z',
          off: 'Spento',
          half: 'Metà',
          full: 'Pieno',
          none: 'Nessuno',
        },
        feedback: {
          visualToggleDeleteConfirm:
            'Sei sicuro di voler eliminare questo dispositivo Visual Toggle?',
          visualToggleDeleteSuccess:
            'Dispositivo Visual Toggle eliminato con successo',
          visualToggleDeleteError:
            'Si è verificato un errore durante il tentativo di ELIMINARE il dispositivo Visual Toggle',
          visualToggleDataKey: 'Chiave dati mancante',
          visualToggleTrigger: 'Trigger mancante',
          visualToggleProperty: 'La proprietà è obbligatoria.',
          visualToggleValue: 'Il valore è obbligatorio.',
          visualToggleUpdated:
            'Dispositivo Visual Toggle aggiornato con successo',
          visualToggleCreated: 'Dispositivo Visual Toggle creato con successo',
          visualToggleSaveError:
            'Si è verificato un errore durante il tentativo di SALVARE il dispositivo Visual Toggle',
        },
      },
      list: {
        header: 'Gestione dispositivi',
        addButton: 'Aggiungi dispositivo',
        emptyState: 'Nessun dispositivo trovato.',
        searchPlaceholder: 'Cerca dispositivi…',
        backButton: 'Torna ai dispositivi',
      },
      validation: {
        nameRequired: 'Il nome del dispositivo è obbligatorio',
        sensorTagMissing: 'Tag sensore mancante per argomento {{index}}.',
        sensorTagTooShort:
          'Il tag sensore per argomento {{index}} deve avere almeno 3 caratteri.',
      },
      feedback: {
        updateSuccess: 'Dispositivo aggiornato con successo',
        updateError: 'Errore durante l’AGGIORNAMENTO del dispositivo',
        createSuccess: 'Dispositivo creato con successo',
        installSuccess: 'Dispositivo installato correttamente',
        createError: 'Errore durante la CREAZIONE del dispositivo',
        duplicateDevice:
          'Un dispositivo con questo numero di serie esiste già.',
        saveError: 'Errore durante il SALVATAGGIO del dispositivo',
        missingAttributes:
          'Errore: attributi mancanti nel payload del dispositivo',
        validationError: 'Errore di convalida',
        serviceUnavailable:
          'Il servizio non è temporaneamente disponibile. Riprova più tardi.',
        bulkInstallSummary:
          'Installati: {installed}. Duplicati: {duplicates}. Non riusciti: {failed}.',
      },
      deviceControls: {
        title: 'Controlli Dispositivo',
        send: 'Invia',
        updateSuccessMessage: 'Setpoint aggiornato con successo',
        updateSuccessTitle: 'Successo',
        updateErrorTitle: 'Errore',
        updateErrorMessage: 'Impossibile aggiornare il setpoint',
        hideAdvanced: 'Nascondi avanzate',
        showAdvanced: 'Mostra avanzate ({count} dispositivi)',
        current: 'Valore',
        range: 'Da',
        duration: 'Durata (ore)',
        durationHelp: 'Il setpoint torna alla pianificazione dopo questo tempo',
        comment: 'Commento',
        commentPlaceholder: 'Perché viene forzato?',
        notLogged:
          'Setpoint aggiornato, ma la forzatura non è stata registrata',
      },
    },

    /* -------------------------- EOS DEVICE LIST ------------------------- */
    eosDevices: {
      energyCategories: {
        electricityGrid: 'Elettricità (rete)',
        electricityGridExport: 'Elettricità esportata (rete)',
        districtHeating: 'Teleriscaldamento',
        districtCooling: 'Teleraffrescamento',
        fossilFuels: 'Combustibili fossili',
        biofuels: 'Biocombustibili',
        solarPV: 'Solare fotovoltaico',
        solarThermal: 'Solare termico',
        otherRenewables: 'Altre rinnovabili (eolico, geotermico)',
        wasteHeat: 'Calore di scarto',
      },
      list: { header: 'Dispositivi EOS' },
      validation: {
        sensorTagMissing: 'Tag sensore mancante per argomento {{index}}.',
        sensorTagTooShort:
          'Il tag sensore per argomento {{index}} deve avere almeno 3 caratteri.',
      },
      feedback: {
        updateSuccess: 'Dispositivo aggiornato con successo',
        updateError: 'Errore durante l’AGGIORNAMENTO del dispositivo',
        createSuccess: 'Dispositivo creato con successo',
        createError: 'Errore durante la CREAZIONE del dispositivo',
        saveError: 'Errore durante il SALVATAGGIO del dispositivo',
      },
    },

    /* --------------------------- EDIT DEVICE ---------------------------- */
    editDevice: {
      title: 'Modifica dispositivo',
      newTitle: 'Nuovo dispositivo',
      deviceName: 'Nome dispositivo',
      deviceDescription: 'Descrizione dispositivo',
      deviceProfile: 'Profilo dispositivo',
      selectDeviceProfile: '- Seleziona profilo dispositivo',
      setpointRange: 'Intervallo Setpoint',
      setpointRangeInfo:
        'Imposta i valori di setpoint superiore e inferiore per il tag sensore, oltre al passo tra i setpoint.',
      minSetpoint: 'Basso Setpoint',
      maxSetpoint: 'Alto Setpoint',
      stepSize: 'Passo',
      controlMode: {
        label: 'Modalità di controllo',
        info: 'Determina come viene regolato il dispositivo quando si attiva il controllo.\nPasso: Regola gradualmente il setpoint su/giù del passo impostato a ogni esecuzione, entro min/max.\nBinario: Passa direttamente al max (più riscaldamento/ventilazione) o al min (meno). Controllo on/off.\nProgramma: Segue solo gli orari di apertura — max all’interno, min all’esterno. Ignora le azioni ASPA.\nSetpoint: Scrive direttamente il setpoint desiderato, limitato a min/max. Aggiorna solo con scostamenti superiori a ±0,1.',
        step: 'Passo',
        binary: 'Binario',
        schedule: 'Programma',
        setpoint: 'Setpoint',
      },
      operatingHoursOnly: 'Controllato solo durante l’orario di funzionamento',
      dynamicSetpoints: {
        label: 'Setpoint dinamici',
        info: 'I setpoint dinamici consentono al dispositivo di sostituire il proprio intervallo di setpoint in base ad altri valori del sensore. Quando il valore del sensore del tag sensore soddisfa la condizione (operatore + soglia), vengono usati il setpoint basso, il setpoint alto e il passo di questa voce al posto del normale intervallo di setpoint del dispositivo.\nTag sensore: il tag sensore monitorato (ad es. comando della batteria di raffreddamento).\nOperatore/soglia: la condizione da soddisfare perché la sostituzione sia attiva.\nSetpoint basso/alto e passo: l’intervallo di setpoint applicato finché la condizione è soddisfatta.',
        add: 'Aggiungi setpoint dinamico',
        deleteTitle: 'Rimuovi setpoint dinamico',
        confirmDelete: 'Vuoi davvero rimuovere questo setpoint dinamico?',
        operator: 'Operatore',
        threshold: 'Soglia',
        validationError:
          'Tutti i campi devono essere compilati per aggiungere un setpoint dinamico.',
        fieldRequired: 'Obbligatorio',
      },
      controllerSettings: 'Impostazioni controller',
      status: {
        active: 'Attivo',
        displayInZone: 'Mostra nella zona',
      },
      display: 'Visualizzazione',
      icon: 'Icona',
      deviceType: {
        label: 'Tipo di dispositivo',
        selectDefault: '- Seleziona tipo di dispositivo',
        sensor: 'Sensore',
        controller: 'Controller',
      },
      dataReceiver: {
        label: 'Ricevitore dati',
        selectDefault: '- Seleziona ricevitore',
        info: 'Indica quale ricevitore deve ricevere i valori di controllo per questo dispositivo.',
      },
      deviceCategory: {
        label: 'Categoria dispositivo',
        selectDefault: 'Seleziona categoria',
      },
      valueMap: 'Mappa i valori del dispositivo in testo (opzionale)',
      setValueMapping: 'Imposta mappatura valori',
      mappedAttribute: {
        label: 'Attributo mappato',
        attribute: 'Attributo',
        numberValue: 'Numero',
        textValue: 'Testo',
        duplicateValueMapping: 'Questo valore esiste già!',
        cancelEditValueMapping: 'Annulla',
        removeValueMapping: 'Rimuovi',
        editValueMapping: 'Modifica',
        deleteTitle: 'Elimina mappatura valore',
        confirmDeleteValueMapping:
          'Sei sicuro di voler eliminare questa mappatura dei valori?',
        confirmDeleteMappedAttributeTitle: 'Elimina attributo mappato',
        confirmDeleteMappedAttribute:
          'Sei sicuro di voler eliminare questo attributo mappato?',
      },
      topics: 'Argomenti',
      inspectDevice: 'Ispeziona dispositivo',
      deleteButton: {
        deleting: 'Eliminazione…',
        label: 'Elimina dispositivo',
      },
      confirmDelete: 'Sei sicuro di voler eliminare questo dispositivo?',
    },

    /* ------------------------- EDIT EOS DEVICE ------------------------- */
    editEosDevice: {
      title: 'Modifica dispositivo EOS',
      newTitle: 'Nuovo dispositivo EOS',
      deviceName: 'Nome dispositivo',
      topics: 'Argomenti',
      deviceDescription: 'Descrizione dispositivo',
      active: 'Attivo',
      producingPower: 'Potenza prodotta',
      includeInBaseline: 'Includi nella baseline',
      deviceSettings: 'Impostazioni dispositivo',
      energyCategory: { label: 'Categoria energetica' },
      provider: {
        label: 'Fornitore',
        required: 'Il fornitore è obbligatorio per il teleriscaldamento',
        options: {
          hafslund: 'Hafslund (Celsio)',
          luneraEnergi: 'Lunera Energi',
        },
      },
      building: 'Edificio',
      allBuildings: 'Tutti gli edifici',
      sensorTypes: {
        HEAT: 'Calore',
        LIGHT: 'Luce',
        HVAC: 'HVAC',
        PRODUCTION: 'Produzione',
        OFFICE: 'Ufficio',
        OTHER: 'Altro',
      },
      icon: 'Icona',
      deviceType: {
        label: 'Tipo di dispositivo',
        selectDefault: '- Seleziona tipo di dispositivo',
        eosSensor: 'Sensore EOS',
        eosSource: 'Fonte EOS',
      },
      sensorConfiguration: 'Configurazione sensore',
      deviceCategory: {
        label: 'Categoria dispositivo',
        selectDefault: 'Seleziona categoria',
      },
      sources: 'Fonti',
      inspectDevice: 'Ispeziona dispositivo',
      deleteButton: {
        deleting: 'Eliminazione…',
        label: 'Elimina dispositivo EOS',
      },
      confirmDelete: 'Sei sicuro di voler eliminare questo dispositivo?',
    },

    /* ---------------------------- CATEGORIES --------------------------- */
    categories: {
      list: {
        header: 'Categorie',
        addButton: 'Aggiungi categoria',
        emptyState: 'Nessuna categoria trovata.',
        searchPlaceholder: 'Cerca categorie…',
        backButton: 'Torna alle categorie',
      },
      feedback: {
        updateSuccess: 'Categoria aggiornata con successo',
        updateError: 'Errore durante l’AGGIORNAMENTO della categoria',
        createSuccess: 'Categoria creata con successo',
        createError: 'Errore durante la CREAZIONE della categoria',
        saveError: 'Errore durante il SALVATAGGIO della categoria',
      },
    },
    editCategory: {
      parentCategory: 'Categoria padre',
      legend: 'Lingua',
      categoryName: 'Nome categoria:',
      languageType: 'Tipo di lingua:',
      selectLanguage: 'Seleziona lingua',
      categoryDescription: 'Descrizione categoria:',
      deleteCategory: 'Elimina categoria',
      deleteConfirm: 'Sei sicuro di voler eliminare questa categoria?',
      categoryType: 'Tipo di categoria',
      validation: {
        categoryRequired: 'È richiesto almeno un tipo di categoria',
        languageRequired: 'La lingua è obbligatoria',
      },
      languageOptions: {
        en: 'Inglese',
        no: 'Norvegese',
        se: 'Svedese',
        de: 'Tedesco',
        fr: 'Francese',
        es: 'Spagnolo',
      },
      categoryTypes: {
        device: 'Dispositivo',
        zone: 'Zona',
        service: 'Servizio',
        resource: 'Risorsa',
        activity: 'Attività',
      },
    },

    /* --------------------------- USER MANAGEMENT ----------------------- */
    userManagement: {
      auditLogs: {
        viewed: 'Visualizzato',
        doneBy: 'Eseguito da',
        noAccess:
          'Serve il livello 4 (amministratore di sistema) o superiore per vedere i registri di audit.',
      },
      auditChanges: {
        readQuery: 'Cosa è stato letto',
        title: 'Cosa è cambiato',
        field: 'Campo',
        before: 'Prima',
        after: 'Dopo',
        created: 'Creato',
        updated: 'Aggiornato',
        deleted: 'Eliminato',
        empty:
          'Nessuna modifica al database è stata registrata per questa richiesta.',
        more: 'Sono stati modificati più record di quelli mostrati qui.',
        hidden: 'Nascosto',
        largeValue: 'Valore grande',
        items: 'elementi',
        sentData: 'Dati inviati',
      },
      list: {
        header: 'Gestione utenti',
        addButton: 'Aggiungi utente',
        emptyState: 'Nessun utente trovato.',
        searchPlaceholder: 'Cerca utenti…',
        backButton: 'Torna agli utenti',
      },
      feedback: {
        fetchError: 'Errore durante il recupero degli utenti',
        updateSuccess: 'Utente aggiornato con successo',
        updateError: 'Errore durante l’AGGIORNAMENTO dell’utente',
        createSuccess: 'Utente creato con successo',
        createError: 'Errore durante la CREAZIONE dell’utente',
        saveError: 'Errore durante il SALVATAGGIO dell’utente',
      },
    },

    editUser: {
      firstName: 'Nome',
      lastName: 'Cognome',
      userInformation: 'Informazioni utente',
      mobileNumber: 'Cellulare',
      email: 'Email',
      password: 'Password',
      enovaOrganization: 'Organizzazione',
      enovaOrganizationNumber: 'Numero di organizzazione',
      enovaPersonalGuid: 'GUID Enova',
      azureAccount: 'ID account Azure',
      role: 'Ruolo',
      active: 'Attivo',
      acceptEmails: 'Accetta email',
      receiveEmails: 'L’utente riceve le email di sistema',
      canLogin: 'L’utente può accedere al sistema',
      hideFeedback: 'Nascondi feedback',
      hidePopups: 'Nascondi popup di feedback',
      changePassword: 'Cambia password',
      successUpdatePassword: 'Password aggiornata',
      errorUpdatePassword: 'Impossibile aggiornare la password',
      passwordFeedback: 'La password deve contenere almeno 8 caratteri',
      addNew: 'Aggiungi nuovo utente',
      calendarSetup: 'Configurazione calendario',
      calendarStartOfDay: 'Inizio giornata (per la vista calendario)',
      calendarEndOfDay: 'Fine giornata',
      tenantAccess: {
        header: 'Accesso tenant',
        label: 'Tenant',
        addAccess: 'Aggiungi accesso',
        selectTenant: '- Seleziona tenant -',
        assignedTenants: 'Tenant assegnati',
        fetchFailed: 'Recupero tenant non riuscito',
        feedback: {
          pleaseSelect: 'Seleziona un tenant',
          alreadyAdded: 'Tenant già aggiunto',
        },
      },
      deleteUser: {
        label: 'Elimina utente',
        deleting: 'Eliminazione…',
      },
      confirmDelete: 'Sei sicuro di voler eliminare questo utente?',
      activityLog: 'Registro attività',
    },

    /* ------------------------ INTEGRATION OVERVIEW --------------------- */
    integrationOverview: {
      edit: {
        details: {
          legend: 'Dettagli',
          nameLabel: 'Nome',
          activeLabel: 'Attivo',
        },
        access: {
          legend: 'Accesso',
          accessLevelLabel: 'Livello di accesso',
          dateFromLabel: 'Data inizio',
          dateToLabel: 'Data fine',
          accessLevelOptions: {
            noAccess: 'Nessun accesso',
            readOnly: 'Sola lettura',
            readAndWrite: 'Lettura e scrittura',
            admin: 'Admin',
          },
        },
        secrets: {
          legend: 'Chiavi',
          revealButton: 'Mostra',
          publicKeyLabel: 'Chiave pubblica',
          secretKeyLabel: 'Chiave segreta',
        },
      },
      feedback: {
        updateSuccess: 'Integrazione aggiornata',
        createSuccess: 'Integrazione creata',
        saveError: 'Salvataggio non riuscito',
        fetchSecretsError: 'Recupero chiavi non riuscito',
        fetchIntegrationsError: 'Recupero integrazioni non riuscito',
      },
    },

    /* -------------------------- THEME SETTINGS ------------------------- */
    themeSettings: {
      header: {
        title: 'Temi',
        subtitle: 'Crea e gestisci i temi visivi della tua azienda',
      },
      feedback: {
        activatedSuccess: 'Tema {themeName} attivato',
        deletedSuccess: 'Tema eliminato',
        updatedSuccess: 'Tema aggiornato',
        createdSuccess: 'Tema creato',
      },
      card: {
        customize: 'Personalizza',
        fallbackDescription: 'Un tema {name}',
        confirmDelete: 'Sei sicuro di voler eliminare il tema "{name}"?',
      },
      globalThemes: {
        sunsetOrange: {
          name: 'Arancio tramonto',
          description:
            'Tonalità arancioni e corallo calde con accenti sabbiosi',
        },
        oceanBlue: {
          name: 'Blu oceano',
          description: "Tonalità blu rinfrescanti ispirate all'oceano",
        },
        crimsonRed: {
          name: 'Rosso cremisi',
          description: 'Cremisi audace guidato da energiche tonalità rosse',
        },
        forestGreen: {
          name: 'Verde foresta',
          description: 'Verdi forestali rilassanti con accenti naturali',
        },
        blackAndWhite: {
          name: 'Bianco e nero',
          description:
            'Contrasto bianco e nero senza tempo per un look moderno',
        },
        classicGray: {
          name: 'Grigio classico',
          description: 'Tema grigio professionale con contrasti sottili',
        },
        modernWhite: {
          name: 'Bianco moderno',
          description:
            "Bianco senza tempo per un'estetica pulita e minimalista",
        },
      },
      dialog: {
        editHeader: 'Modifica tema',
        createHeader: 'Crea tema',
        createTitle: 'Crea nuovo tema',
        createDescription:
          'Progetta un tema personalizzato con i tuoi colori e stile',
        namePlaceholder: 'Nome del tuo tema',
        descriptionPlaceholder: 'Descrivi il tuo tema (opzionale)',
        iconHover: 'Hover icona',
        nameRequired: 'Il nome del tema è obbligatorio',
        customSuffix: '(Personalizzato)',
      },
    },

    /* ----------------------------- VENDOR ------------------------------ */
    vendor: {
      title: 'Generale',
      form: {
        name: 'Nome',
        contactDetails: 'Dettagli contatto',
        street: 'Via',
        postcode: 'CAP',
        city: 'Città',
        country: 'Paese',
        timezone: 'Fuso orario',
        selectTimezone: 'Imposta fuso orario',
        organizationNumber: 'Partita IVA',
        phone: 'Telefono contatto',
        email: 'Email contatto',
        website: 'Sito web aziendale',
        languageDefault: 'Lingua predefinita',
        selectLanguage: 'Imposta lingua',
      },
      modules: {
        title: 'Moduli',
        threeDView: 'Vista 3D',

        requiredAttributes: {
          title: 'Attributi richiesti',
          firstName: 'Nome',
          lastName: 'Cognome',
          phone: 'Telefono',
          email: 'Email',
        },
        buildingAutomation: {
          title: 'Automazione edificio',
          sastechTenantId: 'ID tenant Sastech',
          ignitionProjectName: 'Nome progetto Ignition',
          gridRegion: 'Regione di rete',
          selectGridRegion: '- Seleziona area -',
          gridRegions: {
            NO1: 'Østlandet NO1',
            NO2: 'Sørlandet NO2',
            NO3: 'Midt-Norge NO3',
            NO4: 'Nord-Norge NO4',
            NO5: 'Vestlandet NO5',
          },
        },
        publicDisplay: {
          title: 'Display pubblico',
          loginToDisplay: 'Login al display',
          invalidPassword: 'Password non valida. Riprova.',
          password: 'Password',
          publicLink: 'Link display pubblico:',
          description:
            'Mostra i principali indicatori dell’edificio su uno schermo pubblico senza interfaccia utente',
          placeholder: 'Inserisci nuova password',
          leaveBlankHint: 'Lascia vuoto per mantenere la password attuale.',
          copyButton: 'Copia',
          copySuccess: 'Link copiato negli appunti',
          saveVendorFirst: 'Salva il fornitore per generare un token',
          regenerateButton: 'Rigenera token',
          regenerateWarning: 'Attenzione: questo invaliderà il link esistente',
          confirmRegenerate:
            'Sei sicuro di voler rigenerare il token? Il link esistente verrà invalidato.',
          tokenRegenerated: 'Token rigenerato con successo',
          tokenRegenerateFailed: 'Impossibile rigenerare il token',
        },
      },
      logo: {
        title: 'Logo',
      },
      privacy: {
        title: 'Privacy e anonimizzazione',
        activateAnonymizing: 'Attiva anonimizzazione',
        privacyPolicyText: 'Imposta qui l’intervallo di anonimizzazione',
        monthsToKeepData: 'Mesi di conservazione dei dati',
      },
      keyAccountManager: {
        title: 'Key Account Manager',
        notAssigned: 'Non assegnato',
      },
      tenantStatus: {
        title: 'Stato tenant',
        tenantIsActive: 'Il tenant è attivo',
        status: 'Stato',
        options: {
          development: '1. Sviluppo',
          readyForProduction: '2. Pronto per produzione',
          production: '3. Produzione (sistema)',
          deleted: 'Eliminato',
        },
        markedForDeletion: 'Contrassegnato per eliminazione',
        vendorDeletionTitle: 'Eliminazione fornitore',
        vendorDeletionDescription:
          'Il fornitore verrà eliminato solo se contrassegnato per eliminazione, lo stato è "eliminato" ed è inattivo. Inoltre non deve essere stato modificato negli ultimi 30 giorni.',
      },
      vendorIdLabel: 'ID fornitore',
      successMessage: 'Fornitore aggiornato con successo',
      successMessagePassword: 'Fornitore aggiornato (password modificata)',
      errorMessage: 'Impossibile aggiornare il fornitore',
    },

    /* -------------------------- IMAGE / FILE UPLOAD -------------------- */
    imageUpload: {
      uploadImage: 'Carica immagine',
      noFileSelected: 'Nessun file selezionato',
      uploading: 'Caricamento…',
      fileSizeExceeded: 'File superiore al limite di {{size}} MB.',
      invalidFileType: 'Tipo di file non valido. Seleziona un’immagine.',
      uploadFailed: 'Caricamento non riuscito. Riprova',
      bytes: 'byte',
      dropToReplace: "Rilascia l'immagine per sostituire",
      dragHint: 'Trascina e rilascia qui per sostituire',
      fromFileCloud: 'Cloud file',
      chooseFromFileCloud: 'Scegli da Cloud file',
      convertingHeic: 'Conversione immagine HEIC…',
      heicConversionFailed:
        "Impossibile convertire l'immagine HEIC. Prova con un JPEG o PNG.",
      uploadProgress: 'Caricamento {{done}} di {{total}}…',
      uploadFailedFiles: 'Impossibile caricare: {{names}}',
    },

    fileUpload: {
      uploadImage: 'Carica file',
      noFileSelected: 'Nessun file selezionato',
      uploading: 'Caricamento…',
      fileSizeExceeded: 'File superiore al limite di {{size}} MB.',
      invalidFileType: 'Tipo di file non valido. Seleziona un file valido.',
      uploadFailed: 'Caricamento non riuscito. Riprova',
      fileAlreadyUploaded: 'File già caricato',
      uploadFile: 'Carica file',
      viewUploadedFile: 'Visualizza file caricato',
      uploadNewFile: 'Carica nuovo file',
      fileLabel: 'File:',
      sizeLabel: 'Dimensione:',
    },

    /* ------------------------------- FILE CLOUD ------------------------ */
    fileCloud: {
      title: 'File Cloud',
      storageTitle: 'Magazzinaggio',
      nameLabel: 'Nome',
      folderLabel: 'Cartella',
      sizeLabel: 'Dimensione',
      dateLabel: 'Data caricamento',
      buildingLabel: 'Edificio',
      currentPath: 'Percorso attuale',
      rootLabel: 'Home',
      selectedLabel: 'selezionati',
      gridViewLabel: 'Vista a griglia',
      listViewLabel: 'Vista elenco',
      header:
        'Archivia, organizza e condividi file in modo sicuro nella tua organizzazione',
      uploadFiles: {
        dropZonePrompt: 'Trascina qui i file',
        selectedFilesHeader: 'File selezionati:',
        uploadButton: 'Carica',
        uploadFilesLabel: 'Carica file',
        uploadFolderLabel: 'Carica cartella',
        uploadProgress: 'Caricamento {{done}} di {{total}} file…',
      },
      noFiles: 'Trascina i file',
      noBuildings: 'Nessun edificio disponibile.',
      menu: {
        download: 'Scarica',
        rename: 'Rinomina',
        delete: 'Elimina',
        setBuilding: 'Associa edificio',
        clearBuilding: 'Rimuovi associazione',
      },
      dialog: {
        buildingTitle: 'Seleziona edificio',
        cancelButton: 'Annulla',
        newFolderName: 'Nome nuova cartella',
        createFolder: 'Crea cartella',
        renameFolder: 'Rinomina cartella',
        confirmDeleteTitle: 'Conferma eliminazione',
        confirmDeleteMessage:
          'Sei sicuro di voler eliminare il file selezionato?',
        confirmFolderDeleteMessage:
          'Sei sicuro di voler eliminare la cartella selezionata e tutto il suo contenuto?',
        invalidFolderName:
          'Il nome della cartella contiene caratteri non validi o è vuoto.',
        duplicateFolderName: 'Esiste già una cartella con questo nome.',
        confirmDeleteSelectedMessage:
          'Sei sicuro di voler eliminare i file selezionati?',
      },
      feedback: {
        // existing
        fileDeleted: 'File eliminato con successo',
        buildingCleared: 'Edificio svuotato con successo',
        buildingAssigned: 'Edificio assegnato con successo',
        buildingUpdateError:
          'Impossibile aggiornare il collegamento all’edificio.',

        // Restore file
        fileRestored: 'File ripristinato con successo.',
        restoreSuccessfulTitle: 'Ripristino riuscito',
        restoreErrorMessage: 'Impossibile ripristinare il file.',
        restoreErrorTitle: 'Errore di ripristino',

        // Empty garbage
        garbageEmptied: 'Cestino svuotato con successo.',
        emptyGarbageSuccessfulTitle: 'Svuotamento del cestino riuscito',
        emptyGarbageErrorMessage: 'Impossibile svuotare il cestino.',
        emptyGarbageErrorTitle: 'Errore nello svuotamento del cestino',

        // Move folder to garbage
        folderMovedToGarbage: 'Cartella spostata nel cestino con successo.',
        moveFolderToGarbageSuccessfulTitle: 'Spostamento nel cestino riuscito',
        moveFolderToGarbageErrorMessage:
          'Impossibile spostare la cartella nel cestino.',
        moveFolderToGarbageErrorTitle: 'Errore nello spostamento nel cestino',

        // Rename folder
        folderRenamed: 'Cartella rinominata con successo.',
        renameFolderSuccessfulTitle: 'Rinomina riuscita',
        renameFolderErrorMessage: 'Impossibile rinominare la cartella.',
        renameFolderErrorTitle: 'Errore di rinomina',

        // Move folder
        folderMoved: 'Cartella spostata con successo.',
        moveFolderSuccessfulTitle: 'Spostamento riuscito',
        moveFolderErrorMessage: 'Impossibile spostare la cartella.',
        moveFolderErrorTitle: 'Errore di spostamento',

        // Delete file
        deleteSuccessfulTitle: 'Eliminazione riuscita',
        deleteErrorMessage: 'Impossibile eliminare il file.',
        deleteErrorTitle: 'Errore di eliminazione',

        // Move file
        moveFileErrorMessage: 'Impossibile spostare il file.',
        moveFileErrorTitle: 'Errore di spostamento',

        // Create folder
        createFolderErrorMessage: 'Impossibile creare la cartella.',
        createFolderErrorTitle: 'Errore di creazione cartella',

        // Upload
        uploadSuccessfulMessage: 'File caricati con successo.',
        uploadSuccessfulTitle: 'Caricamento riuscito',
        uploadErrorTitle: 'Errore di caricamento',
      },
      newFolder: 'Nuova cartella',
      confirmDeleteFolder:
        'Sei sicuro di voler eliminare questa cartella e tutto il suo contenuto?',
      moveToRoot: 'Sposta nella cartella principale',
    },

    /* -------------------------- GENERIC FEEDBACK ----------------------- */
    feedback: {
      vendorLoad: {
        title: 'Errore',
        message: 'Impossibile caricare le informazioni del fornitore',
      },
    },
    degreeDays: {
      error: "L'edificio non dispone di coordinate GPS",
    },
  },
  feedback: {
    open: 'Feedback',
    title: 'Invia feedback',
    close: 'Chiudi',
    messageLabel: 'Messaggio',
    placeholder: 'Inserisci il tuo feedback qui…',
    screenshotTitle: 'Carica uno screenshot',
    send: 'Invia',
    infoPrefix: 'Per maggiori informazioni consulta il nostro',
    helpCenter: 'Centro assistenza',
    statusPage: 'Pagina stato',
  },
  admin: {
    buildingInspection: BUILDING_INSPECTION,
    energyLabelLeads: ENERGY_LABEL_LEADS,
    siteInspection: {
      deleteNoSiteInspectionsMessage:
        "Nessuna ispezione edilizia selezionata per l'eliminazione.",
      deleteConfirmMessage:
        'Sei sicuro di voler eliminare questa ispezione edilizia? Questa azione non può essere annullata.',
      deleteSuccessMessage: "L'ispezione edilizia è stata eliminata.",
      deleteErrorMessage: "Impossibile eliminare l'ispezione edilizia.",
      updateSuccessMessage: "L'ispezione edilizia è stata aggiornata.",
      createSuccessMessage: "L'ispezione edilizia è stata creata.",
      failedToLoadMessage:
        'Impossibile caricare le ispezioni edilizie. Riprova più tardi.',
      saveErrorMessage:
        "Impossibile salvare l'ispezione edilizia. Riprova più tardi.",
      buildingErrorMessage: "Seleziona un edificio per l'ispezione edilizia.",
      buildingTypeErrorMessage:
        "Seleziona un tipo di edificio per l'ispezione edilizia.",
      failedToLoadBuildingsMessage:
        'Impossibile caricare gli edifici. Riprova più tardi.',
      calculationsCompleteMessage: 'Calcoli completati',
      //Header
      title: 'Ispezione edilizia',
      subtitle:
        "Completa l'ispezione edilizia utilizzando il modulo sottostante",
      newInspectionLabel:
        'Nuova ispezione, salva per abilitare ulteriori opzioni.',
      reportLabel: 'Rapporto',
      actionsLabel: 'Azioni correttive',
      generalLabel: 'Generale',
      //Info
      status: {
        statusLabel: 'Stato',
        draft: 'Bozza',
        completed: 'Completata',
        inReview: 'In revisione',
      },
      buildingLabel: 'Edificio',
      buildingTypeLabel: 'Tipologia di edificio (Norma UNI)',
      notesLabel: 'Note',
      buildingTypes: {
        label: {
          smallHouse: 'Casa unifamiliare',
          apartmentBlock: 'Edificio residenziale multipiano',
          kinderGarden: 'Asilo nido / Scuola materna',
          officeBuilding: 'Edificio per uffici',
          schoolBuilding: 'Edificio scolastico',
          universityCollege: 'Università / Istituto superiore',
          hospital: 'Ospedale',
          nursingHome: 'Casa di riposo',
          hotel: 'Hotel',
          sportsBuilding: 'Edificio sportivo',
          commercialBuilding: 'Edificio commerciale',
          culturalBuilding: 'Edificio culturale',
          lightIndustryWarehouse: 'Industria leggera / Magazzino',
        },
        description: {
          smallHouse:
            'Casa unifamiliare, bifamiliare, a schiera o altre abitazioni di piccole dimensioni.',
          apartmentBlock:
            'Edificio residenziale con due o più piani, inclusi grandi case a schiera su più livelli.',
          kinderGarden:
            'Edifici destinati ad asili nido o all’educazione della prima infanzia.',
          officeBuilding:
            'Uffici semplici, con ventilazione e raffreddamento, o edifici per esposizioni e congressi.',
          schoolBuilding:
            'Strutture scolastiche, incluse scuole con piscina o palestra.',
          universityCollege:
            'Edifici universitari o di istituti superiori, laboratori o strutture di ricerca.',
          hospital: 'Ospedali, hotel per pazienti o laboratori per uso medico.',
          nursingHome:
            'Case di riposo destinate a soggiorni e cure di lunga durata.',
          hotel: 'Hotel, edifici per ristorazione o altre strutture ricettive.',
          sportsBuilding:
            'Palestre, piscine e altri impianti sportivi con spogliatoi e docce.',
          commercialBuilding:
            'Negozi, locali commerciali con celle frigorifere o stazioni di servizio.',
          culturalBuilding: 'Cinema, musei, biblioteche ed edifici religiosi.',
          lightIndustryWarehouse:
            'Stabilimenti industriali, magazzini, edifici agricoli o ittici, impianti energetici o altri laboratori.',
        },
      },
      mainTabs: {
        info: 'Informazioni',
        climate: 'Clima',
        zones: 'Zone',
        hvac: 'HVAC e operazioni',
        heatingCooling: 'Riscaldamento e raffreddamento',
        excessEnergy: 'Energia in eccesso',
        analytics: 'Analisi',
        attachments: 'Allegati',
      },
      footerButtons: {
        next: 'Avanti',
        previous: 'Precedente',
      },
      climate: {
        averageMonthlyTemp: 'Temperatura media mensile (°C)',
        globalIrradiation: 'Irradiazione globale (kWh/m²)',
        diffuseIrradiation: 'Irradiazione diffusa (kWh/m²)',
        albedo: 'Albedo (0–1)',
      },
      hvacTabs: {
        hvacUnits: 'Unità HVAC',
        operationalLoads: 'Carichi operativi',
        productionEquipment: 'Apparecchiature di produzione',
      },
      zoneManager: {
        area: 'Superficie (m²)',
        noZonesCreatedYet: 'Nessuna zona è ancora stata creata',
        createZoneToBegin:
          'Crea una zona per iniziare a raccogliere i dati dell’involucro edilizio. Puoi selezionare una zona esistente oppure crearne una nuova specifica per questa ispezione.',
        subTabs: {
          buildingEnvelope: 'Involucro edilizio',
          windows: 'Finestre',
          doors: 'Porte',
          gates: 'Cancelli',
          airLeakage: 'Perdite d’aria',
          thermalMass: 'Massa termica',
        },
        zoneSelector: {
          createFirstZone: 'Crea la prima zona',
          addZone: 'Aggiungi zona',
          deleteSelectedZone: 'Elimina la zona selezionata',
          linked: 'Collegato',
        },
        zoneCreateModal: {
          zoneNameError: 'Il nome della zona è obbligatorio.',
          createNewZoneLabel: 'Crea nuova zona',
          linkExistingZoneLabel: 'Collega zona esistente',
          linkExistingZoneHelperText:
            'Seleziona una zona esistente da collegare a questa ispezione.',
          selectZonePlaceholder: 'Seleziona una zona...',
          createNewZoneHelperText:
            'Crea una nuova zona che verrà aggiunta all’edificio e utilizzata per questa ispezione.',
          zoneName: 'Nome della zona',
          description: 'Descrizione',
          cancelButtonLabel: 'Annulla',
          addZoneTitle: 'Aggiungi zona',
          zoneNameLabel: 'Nome della zona',
          descriptionLabel: 'Descrizione',
        },
        exteriorWalls: 'Pareti esterne',
        helperWithHistory: {
          north: 'Nord',
          south: 'Sud',
          east: 'Est',
          west: 'Ovest',
          count: 'Numero',
          width: 'Larghezza (m)',
          height: 'Altezza (m)',
          addToArea: 'Aggiungi alla superficie (m²)',
          history: 'Cronologia',
          entry: ' calcolo',
          entries: ' calcoli',
          inputHistory: 'Cronologia dei calcoli',
          helperTitle: 'Calcolatore di superfici',
        },
        windows: {
          glassType: 'Tipo di vetro',
          windowTypes: [
            'Nessuno',
            'Vetro singolo',
            'Doppio vetro',
            'Doppio vetro basso emissivo',
            'Doppio vetro a controllo solare',
            'Triplo vetro basso emissivo',
          ],
          totalWindowsArea: 'Superficie totale delle finestre (m²)',
          sumOfAllWindowsSurfaces: 'Somma di tutte le superfici finestrate',
          averageUValue: 'Valore U medio (W/m²K)',
          averageUValueFormula: '(Σ(U × superficie)) / Σ(superficie)',
          winAreaAsPercentageOfFacade:
            'Superficie finestrata in % della facciata',
          winAreaAsPercentageOfFacadeFormula:
            'Superficie totale delle finestre / Superficie totale di facciata × 100',
        },
        buildingEnvelope: {
          bra: 'Superficie utile riscaldata (m²)',
          floors: 'Numero di piani',
          floorHeight: 'Altezza interpiano (m)',
          indoorTemperature: 'Temperatura interna (°C)',
          heatedVolume: 'Volume d’aria riscaldato (m³)',
          heatedVolumeFormula:
            'Superficie utile riscaldata × altezza interpiano',
          thermalBridge: 'Ponte termico',
          thermalBridgeFormula:
            'Superficie riscaldata × valore normativo × Kelvin',
          totalExternalWallArea: 'Superficie totale delle pareti esterne',
          totalExternalWallAreaFormula:
            'Somma di tutte le superfici delle pareti esterne',
          thermalBridgeCoefficient: 'Coefficiente di ponte termico (W/mK)',
          extwWallConstruction: 'Tipo di costruzione della parete esterna',
          groundConditions: {
            title: 'Condizioni del terreno',
            options: {
              none: 'Nessuno',
              clay: 'Argilla',
              drySandGravel: 'Sabbia/ghiaia (secca)',
              moistSandGravel: 'Sabbia/ghiaia (umida)',
              wetSandGravel: 'Sabbia/ghiaia (bagnata)',
              rock: 'Roccia',
              moraine: 'Moraine',
              dryPeat: 'Torba (secca)',
              moistPeat: 'Torba (umida)',
              wetPeat: 'Torba (bagnata)',
              silt: 'Limo',
              organicSoil: 'Suolo organico',
            },
            heatCapacity: 'Capacità termica (J/m²K)',
            thermalConductivity: 'Conducibilità termica (W/mK)',
            groundTemperature: 'Temperatura del terreno (°C)',
          },
          grossArea: 'Superficie lorda (m²)',
          netArea: 'Superficie netta (m²)',
          netAreaFormula: 'Superficie pareti − Finestre − Porte − Portoni',
          wallConstruction: {
            title: 'Struttura della parete',
          },
          uValue: 'Valore U (W/m²K)',
          shadingFactor: 'Fattore di ombreggiamento',
          area: 'Superficie (m²)',
          yearInstalled: 'Anno di installazione',
          yearInstalledNone: 'Nessuno',
          yearInstalledBefore1949: 'Prima del 1949',
          yearInstalledFrom1997: 'Dal 1997 in poi',
          floor: {
            area: 'Superficie pavimento (m²)',
            uValue: 'Valore U del pavimento (W/m²K)',
            title: 'Pavimento',
            options: {
              title: 'Tipo di materiale del pavimento',
              standard: 'Standard',
              tiles: 'Piastrelle (7 mm) + calcestruzzo',
              flooringChipBoard:
                'Rivestimento (4 mm) + pannello truciolare 22 mm',
              flooringConcrete: 'Rivestimento (4 mm) + calcestruzzo',
              flooringLWA:
                'Rivestimento (4 mm) + solaio in calcestruzzo leggero (LECA)',
              parquetChipBoard: 'Parquet (14 mm) + pannello truciolare 22 mm',
              parquetConcrete: 'Parquet (14 mm) + calcestruzzo',
              parquetLWA:
                'Parquet (14 mm) + solaio in calcestruzzo leggero (LECA)',
              carpetChipBoard: 'Moquette (10 mm) + pannello truciolare 22 mm',
              carpetConcrete: 'Moquette (10 mm) + calcestruzzo',
              carpetLWA:
                'Moquette (10 mm) + solaio in calcestruzzo leggero (LECA)',
            },
          },
          roof: {
            title: 'Tetto',
            optionsTitle: 'Struttura del tetto',
            area: 'Superficie del tetto (m²)',
            uValue: 'Valore U del tetto (W/m²K)',
            options: [
              'Standard',
              'Tetto compatto con 200–250 mm di calcestruzzo, 200 mm di isolamento',
              'Tetto compatto con 200–250 mm di calcestruzzo, 250 mm di isolamento',
              'Tetto compatto con 200–250 mm di calcestruzzo, 300 mm di isolamento',
              'Tetto compatto con 200–250 mm di calcestruzzo, 350 mm di isolamento',
              'Tetto compatto con 200–250 mm di calcestruzzo, 400 mm di isolamento',
              'Tetto compatto con 200–250 mm di calcestruzzo, 450 mm di isolamento',
              'Tetto compatto con 200–250 mm di calcestruzzo, 500 mm di isolamento',
              'Tetto compatto con lamiera grecata, 200 mm di isolamento',
              'Tetto compatto con lamiera grecata, 250 mm di isolamento',
              'Tetto compatto con lamiera grecata, 300 mm di isolamento',
              'Tetto compatto con lamiera grecata, 350 mm di isolamento',
              'Tetto compatto con lamiera grecata, 400 mm di isolamento',
              'Tetto compatto con lamiera grecata, 450 mm di isolamento',
              'Tetto compatto con lamiera grecata, 500 mm di isolamento',
              'Tetto a falde con travi 48 mm (9 % area), 200 mm di isolamento',
              'Tetto a falde con travi 48 mm (9 % area), 250 mm di isolamento',
              'Tetto a falde con travi 48 mm (9 % area), 300 mm di isolamento',
              'Tetto a falde con travi 48 mm (9 % area), 350 mm di isolamento',
              'Tetto a falde con travi 48 mm (9 % area), 400 mm di isolamento',
              'Tetto a falde con travi a I (6 % area), 200 mm di isolamento',
              'Tetto a falde con travi a I (6 % area), 250 mm di isolamento',
              'Tetto a falde con travi a I (6 % area), 300 mm di isolamento',
              'Tetto a falde con travi a I (6 % area), 350 mm di isolamento',
              'Tetto a falde con travi a I (6 % area), 400 mm di isolamento',
              'Tetto a falde con travi a I (6 % area), 450 mm di isolamento',
              'Tetto a falde con travi a I (6 % area), 500 mm di isolamento',
              'Tetto a falde con travi a I (6 % area), 550 mm di isolamento',
              'Tetto con sottotetto freddo, travi 48 mm (9 % area), 200 mm di isolamento',
              'Tetto con sottotetto freddo, travi 48 mm (9 % area), 250 mm di isolamento',
              'Tetto con sottotetto freddo, travi 48 mm (9 % area), 300 mm di isolamento',
              'Tetto con sottotetto freddo, travi 48 mm (9 % area), 350 mm di isolamento',
              'Tetto con sottotetto freddo, travi 48 mm (9 % area), 400 mm di isolamento',
              'Tetto con sottotetto freddo, travi 48 mm (9 % area), 450 mm di isolamento',
              'Tetto con sottotetto freddo, travi 48 mm (9 % area), 500 mm di isolamento',
              'Tetto con sottotetto freddo, travi 48 mm (9 % area), 550 mm di isolamento',
            ],
          },
          basement: {
            title: 'Seminterrato',
            area: 'Superficie del seminterrato (m²)',
            wallHeight: 'Altezza parete (m)',
            wallThickness: 'Spessore parete (m)',
            baseWallConstruction: 'Struttura della parete',
            wallUValue: 'Valore U (W/m²K)',
            heatStorage: 'Tipo di accumulo termico',
            effectiveHeatCapacity: 'Capacità termica effettiva (kJ/m²K)',
            floorConstruction: 'Struttura del pavimento',
            baseWallConstructionType: 'Tipo di struttura della parete',
            baseWallConstructionOptions: [
              'Standard',
              '200 mm calcestruzzo con 100 mm di isolamento',
              '200 mm calcestruzzo con 150 mm di isolamento',
              '200 mm calcestruzzo con 200 mm di isolamento',
              '200 mm calcestruzzo con 250 mm di isolamento',
              '200 mm calcestruzzo con 300 mm di isolamento',
              '300 mm calcestruzzo con 100 mm di isolamento',
              '300 mm calcestruzzo con 150 mm di isolamento',
              '300 mm calcestruzzo con 200 mm di isolamento',
              '300 mm calcestruzzo con 250 mm di isolamento',
              '300 mm calcestruzzo con 300 mm di isolamento',
            ],
            heatStorageTypes: [
              'Nessuno',
              'Leggero (< 50 Wh/m²K)',
              'Medio (50–100 Wh/m²K)',
              'Pesante (100–150 Wh/m²K)',
              'Molto pesante (> 150 Wh/m²K)',
              'Calcestruzzo 100 mm',
              'Calcestruzzo 150 mm',
              'Calcestruzzo 200 mm',
              'Calcestruzzo 250 mm',
              'Calcestruzzo 300 mm',
              'Legno',
              'Cartongesso',
            ],
            floorConstructionTypes: [
              'Nessuno',
              'Standard',
              'Solaio su terra con 100 mm di isolamento',
              'Solaio su terra con 150 mm di isolamento',
              'Solaio su terra con 200 mm di isolamento',
              'Solaio su terra con 250 mm di isolamento',
              'Solaio su terra con 300 mm di isolamento',
              'Solaio su terra con 350 mm di isolamento',
              'Solaio su terra con 400 mm di isolamento',
              'Solaio in legno con 200 mm di isolamento',
              'Solaio in legno con 250 mm di isolamento',
              'Solaio in legno con 300 mm di isolamento',
            ],
          },
        },
        doors: {
          title: 'Tipo di porta',
          yearInstalled: 'Anno di installazione',
          totalArea: 'Superficie totale delle porte',
          totalAreaFormula: 'Somma di tutte le superfici delle porte',
          avgUValue: 'Valore U medio (porte)',
          avgUValueFormula: '(Σ(U × superficie)) / Σ(superficie)',
          percentageOfFacade: 'Superficie porte in % della facciata',
          percentageOfFacadeFormula:
            'Superficie totale delle porte / Superficie totale di facciata × 100',
          doorTypes: [
            'Nessuna',
            'Standard',
            'Isolata',
            'Normale',
            'Ben isolata',
            'Non isolata',
          ],
        },
        gates: {
          title: 'Tipo di portone',
          yearInstalled: 'Anno di installazione',
          totalArea: 'Superficie totale dei portoni',
          totalAreaFormula: 'Somma di tutte le superfici dei portoni',
          avgUValue: 'Valore U medio (portoni)',
          avgUValueFormula: '(Σ(U × superficie)) / Σ(superficie)',
          percentageOfFacade: 'Superficie portoni in % della facciata',
          percentageOfFacadeFormula:
            'Superficie totale dei portoni / Superficie totale di facciata × 100',
        },
        airLeakage: {
          airLeakageRate: 'Perdita d’aria (l/s·m² a 50 Pa)',
          airChangeRate: 'Tasso di ricambio d’aria (ACH a 50 Pa)',
          naturalVentilation: 'Ventilazione naturale',
        },
        thermalMass: {
          buildingHeatCapacity: 'Capacità termica totale dell’edificio',
          heatCapacitySelectTitle: 'Tipologia di edificio (NS 3031 B.2.8)',
          shortDescriptionFirstOption:
            'Solaio leggero, sottile rivestimento di pavimento, pareti leggere',
          shortDescriptionSecondOption:
            'Soffitto acustico, moquette su calcestruzzo, pareti leggere',
          shortDescriptionThirdOption:
            'Poca superficie in calcestruzzo a vista (20 %), parquet su calcestruzzo',
          shortDescriptionFourthOption:
            'Prevalentemente calcestruzzo a vista (70 %)',
          shortDescriptionFifthOption:
            'Calcestruzzo a vista in soffitto, pareti e pavimento',
          labelFirstOption: 'Edificio molto leggero',
          labelSecondOption: 'Edificio leggero',
          labelThirdOption: 'Edificio medio-pesante',
          labelFourthOption: 'Edificio pesante',
          labelFifthOption: 'Edificio molto pesante',
          normalizedHeatCapacity: 'Capacità termica normalizzata [Wh/(m²·K)]',
          normalizedHeatCapacityHelper:
            'Da NS 3031 Tabella B.8 – Utilizzata nel calcolo energetico dinamico',
          interiorWalls: 'Pareti interne',
          north: 'Nord',
          south: 'Sud',
          east: 'Est',
          west: 'Ovest',
          claddingTitle: 'Tipo di rivestimento',
          cladding: [
            'Personalizzato',
            'Standard',
            'Calcestruzzo 100 mm (o più)',
            'Calcestruzzo 80 mm',
            'Calcestruzzo cellulare',
            'Cartongesso 13 mm',
            'Mattone leggero',
            'Calcestruzzo leggero (argilla espansa)',
            'Legno massiccio (spessore > 40 mm)',
            'Rivestimento in legno 15 mm',
            'Mattone pieno (pesante)',
          ],
          claddingSubText: 'Definito dall’utente',
          internalConstruction: 'Struttura interna',
          heatCapacity: 'Capacità termica [Wh/m²K]',
          grade: 'Classe',
          furniture: {
            title: 'Arredi',
            options: ['Nessuno', 'Standard', 'Leggero', 'Medio', 'Pesante'],
          },
          thermalHeatCapacityLabel: 'Capacità termica dell’edificio',
          thermalHeatCapacityFormula:
            'Superficie utile riscaldata × valore normativo / 1000 (Norma: Nessuno = 0, Leggero = 40, Medio = 60, Pesante = 80 Wh/m²K)',
          floorSeparationsAreaLabel: 'Superficie dei solai interpiano (m²)',
          internalFloorsTooltip:
            'Solaio interno tra i piani: superficie utile riscaldata × (numero di piani − 1) / numero di piani',
        },
      },
    },
    report: {
      noReportYetTitle: 'Nessun rapporto ancora',
      noReportYetDescription:
        'Crea una prima bozza del rapporto per iniziare a documentare l’ispezione.',
      noReportYetSubDescription:
        'Il rapporto includerà capitoli, campi di testo e allegati organizzati in un formato strutturato.',
      creatingDraft: 'Creazione bozza…',
      createDraft: 'Crea bozza',

      title: 'Rapporto',
      reportGenerationHint1:
        'Per generare il rapporto, lo stato dell’ispezione deve essere impostato su completato.',
      reportGenerationHint2:
        'I rapporti vengono generati ogni quindici minuti.',
      reportGenerationHint3:
        'I dati vengono recuperati dall’ispezione quando lo stato è impostato su completato.',

      statusDraft: 'Bozza',
      statusAiGenerate: 'Generazione AI',
      statusComplete: 'Completato',

      reportGenerationTitle: 'Generazione del rapporto',
      reportGenerationLine1:
        'Per generare il rapporto, lo stato dell’ispezione deve essere impostato su completato. I rapporti vengono generati ogni quindici minuti.',
      reportGenerationLine2:
        'I dati vengono recuperati dall’ispezione quando lo stato è impostato su completato.',

      tableOfContents: 'Indice',

      olderVersionWarning:
        'Attenzione! Stai visualizzando una versione precedente di questo rapporto.',

      saving: 'Salvataggio…',
      saveReport: 'Salva rapporto',
      deleteReport: 'Elimina rapporto',

      confirmDeletionTitle: 'Conferma eliminazione',
      confirmDeleteReportMessage:
        'Sei sicuro di voler eliminare questo rapporto?',
      confirmDeleteTextFieldMessage:
        'Sei sicuro di voler eliminare questo campo di testo?',

      addField: 'Aggiungi campo',
      fieldSingular: 'campo',
      fieldsPlural: 'campi',

      aiPrompt: 'Prompt AI',
      reportText: 'Testo del rapporto',
      attachments: 'Allegati',
      addImage: 'Aggiungi immagine',

      aiLabel: 'AI',
      scoreLabel: 'Punteggio',

      versionLabel: 'Versione',

      exportToWord: 'Esporta in Word',
      exportingWord: 'Esportazione...',
      wordExportProgress: {
        starting: 'Avvio esportazione...',
        capturingCharts: 'Acquisizione grafici...',
        capturingDetails: 'Acquisizione dettagli di calcolo...',
        buildingDocument: 'Creazione documento...',
        savingFile: 'Salvataggio file...',
        complete: 'Esportazione completata',
        error: 'Esportazione fallita. Riprova.',
      },
    },
    UserCalendar: {
      createYourActivity: 'Crea la tua attività',
      categoryErrorMessage: 'Categoria mancante',
      titleErrorMessage: 'Titolo mancante',
      createActivity: 'Crea attività',
      editActivity: 'Modifica attività',
      confirmDeletion: 'Conferma eliminazione',
      deleteMessage: 'Sei sicuro di voler eliminare questa attività?',
    },
  },
  attachments: {
    notes: 'Note',
    description: 'Descrizione',
    replaceImage: 'Sostituisci immagine',
    removeAttachment: 'Rimuovi allegato',
    addImage: 'Aggiungi immagine',
    tags: 'Argomenti',
    uploadImage: 'Carica screenshot',
  },
  buildingControlProfile: {
    inOperationTitle: 'In funzione',
    outsideOperationTitle: 'Fuori funzione',
    temperatureLower: 'Limite inferiore di temperatura (°C)',
    temperatureUpper: 'Limite superiore di temperatura (°C)',
    humidityLower: 'Limite inferiore di umidità (%)',
    humidityUpper: 'Limite superiore di umidità (%)',
    co2Tooltip: 'Livello massimo di CO₂ consentito, misurato in ppm.',
    refreshInterval: 'Intervallo di aggiornamento',
    refreshIntervalHelp: 'Frequenza con cui l’ASPA verifica questi parametri.',
    comfortWeight: 'Peso del comfort',
    energy: 'Energia',
    comfort: 'Comfort',
    costInfo:
      'L’ottimizzatore bilancia consumo energetico e comfort. Un peso del comfort basso privilegia un basso consumo energetico, mentre un peso del comfort elevato privilegia un comfort migliore. Entrambi i valori sono calcolati su una scala da 0 a 1.',
  },
  gridRegions: {
    label: 'Zona elettrica',
    placeholder: '- Seleziona zona -',
    groups: {
      nordic: 'Paesi nordici',
      centralEurope: 'Europa centrale',
      southernEurope: 'Europa meridionale',
      baltic: 'Stati baltici',
      britishIsles: 'Isole britanniche',
      easternEurope: 'Europa orientale',
    },
    areas: {
      NO1: 'Oslo / Norvegia orientale',
      NO2: 'Kristiansand / Norvegia meridionale',
      NO3: 'Trondheim / Norvegia centrale',
      NO4: 'Tromsø / Norvegia settentrionale',
      NO5: 'Bergen / Norvegia occidentale',
      SE1: 'Svezia settentrionale',
      SE2: 'Svezia centro-settentrionale',
      SE3: 'Svezia centrale',
      SE4: 'Svezia meridionale',
      DK1: 'Danimarca occidentale (Jutland-Fionia)',
      DK2: 'Danimarca orientale (Selandia)',
      FI: 'Finlandia',
      DE_LU: 'Germania-Lussemburgo',
      AT: 'Austria',
      BE: 'Belgio',
      NL: 'Paesi Bassi',
      FR: 'Francia',
      CH: 'Svizzera',
      CZ: 'Repubblica Ceca',
      PL: 'Polonia',
      SK: 'Slovacchia',
      HU: 'Ungheria',
      SI: 'Slovenia',
      HR: 'Croazia',
      IT_NORTH: 'Italia Nord',
      IT_CNORTH: 'Italia Centro-Nord',
      IT_CSOUTH: 'Italia Centro-Sud',
      IT_SOUTH: 'Italia Sud',
      IT_SICILY: 'Italia Sicilia',
      IT_SARDINIA: 'Italia Sardegna',
      ES: 'Spagna',
      PT: 'Portogallo',
      GR: 'Grecia',
      EE: 'Estonia',
      LV: 'Lettonia',
      LT: 'Lituania',
      GB: 'Gran Bretagna',
      IE_SEM: 'Irlanda (SEM)',
      RO: 'Romania',
      BG: 'Bulgaria',
      RS: 'Serbia',
      ME: 'Montenegro',
      AL: 'Albania',
      MK: 'Macedonia del Nord',
      BA: 'Bosnia ed Erzegovina',
      XK: 'Kosovo',
    },
  },
  addressSearch: {
    label: 'Cerca per indirizzo',
    placeholder: 'Via, numero e località',
    moreHint:
      'Mostra {shown} di {total}. Aggiungi una località o un CAP per restringere la ricerca.',
    noHitsHint:
      'Nessun risultato. Aggiungi numero civico e località, ad esempio Storgata 1 Oslo.',
  },
  energyLabelForm: {
    eyebrow: 'Attestato energetico',
    language: 'Lingua',
    themeLight: 'Passa al tema chiaro',
    themeDark: 'Passa al tema scuro',
    title: 'Etichetta energetica',
    loggedInAs: 'Connesso come',
    logout: 'Esci',
    login: {
      title: 'Accedi',
      phoneDescription:
        "Accedi con il numero di telefono utilizzato per richiedere l'attestato energetico (Energiattest). Un codice di verifica viene inviato via SMS.",
      codeDescription: 'Inserisci il codice a sei cifre ricevuto via SMS.',
      phone: 'Numero di telefono',
      phonePlaceholder: '312 345 6789',
      countryCode: 'Prefisso internazionale',
      phoneHint: 'Il numero indicato al momento della richiesta.',
      code: 'Codice di verifica',
      codeHint: 'Sei cifre ricevute via SMS.',
      codeSentTo: 'Codice inviato a',
      sendCode: 'Invia codice',
      verify: 'Verifica',
      changePhone: 'Usa un altro numero di telefono',
    },
    flow: {
      navTitle: 'Come procedere',
      draftSavedAt: 'La tua bozza — ultimo salvataggio',
      continueLater: 'Puoi chiudere e continuare più tardi.',
      draft: 'Bozza',
      saveAndClose: 'Salva e chiudi',
      autosaved: 'Le tue risposte vengono salvate automaticamente.',
      submitted: {
        title: 'Inviato',
        body: 'Grazie. Un consulente energetico esaminerà le tue risposte.',
      },
      back: 'Indietro',
      next: 'Avanti',
      submit: 'Invia',
      stepsMenu: 'Passaggi',
      whyWeAsk: 'Perché lo chiediamo?',
      validation: {
        range: 'Deve essere compreso tra {min} e {max}.',
        min: 'Deve essere almeno {min}.',
        max: 'Non può superare {max}.',
        positive: 'Deve essere maggiore di zero.',
      },
      select: 'Seleziona',
      gnr: 'Gnr',
      bnr: 'bnr',
      buildingNumberShort: 'n. edificio',
      building: {
        address: 'Indirizzo',
        buildingNumber: 'N. edificio',
        cadastre: 'Gnr / bnr',
        buildingType: 'Tipo di edificio',
        usableArea: 'Superficie utile (BRA)',
        footprint: 'Superficie coperta',
      },
      cadastre: {
        notFound: 'Edificio non trovato nel catasto. Inserisci ciò che sai.',
      },
      yesNo: { yes: 'Sì', no: 'No', dontKnow: 'Non so' },
      status: {
        completed: 'Completato',
        defaults: 'Valori predefiniti',
        notApplicable: 'Non applicabile',
      },
      steps: {
        confirmBuilding: {
          nav: "Conferma l'edificio",
          title: "Conferma l'edificio",
          eyebrow: 'Trovato tramite GPS e catasto',
          question: 'È questo il tuo edificio?',
          body: "Abbiamo evidenziato l'edificio più vicino alla tua posizione. Controlla che indirizzo e numero di edificio siano corretti prima di continuare.",
          wrongHint:
            "Non è corretto? Tocca l'edificio giusto sulla mappa, oppure cerca per indirizzo.",
          searchAddress: 'Cerca per indirizzo',
          mapTitle: 'Selettore edificio',
          noBuilding:
            "Nessun edificio trovato qui. Avvicina il marcatore all'edificio.",
        },
        aboutBuilding: {
          nav: "Sull'edificio",
          title: "Sull'edificio",
          lead: "La maggior parte dei dati qui sotto proviene dal catasto. Correggi ciò che non è corretto — l'attestato si basa su questi numeri.",
          aside: {
            title: 'Categoria, anno di costruzione e superficie',
            body: "Categoria dell'edificio, anno di costruzione e superficie utile sono la base di tutto il calcolo. La categoria stabilisce i valori predefiniti, l'anno di costruzione indica quali norme edilizie erano in vigore, e la superficie decide quanta energia usa l'edificio per metro quadrato.",
          },
          sections: {
            category: {
              title: 'Categoria di edificio',
              description:
                'La categoria determina quali valori predefiniti vengono usati in seguito.',
            },
            area: {
              title: 'Superficie e altezza',
              description:
                'La superficie coperta può essere letta anche dalla mappa.',
            },
          },
          fields: {
            category: {
              label: 'Categoria',
              hint: 'Ricavato dal catasto quando risulta registrato.',
            },
            subcategory: {
              label: 'Sottocategoria',
              hint: 'Ricavato dal catasto quando risulta registrato.',
            },
            buildYear: {
              label: 'Anno di costruzione',
              hint: "L'anno di inizio dei lavori, se noto.",
            },
            floors: {
              label: 'Numero di piani',
              hint: 'Fuori terra. Il seminterrato viene aggiunto dopo.',
            },
            footprint: {
              label: 'Superficie coperta',
              hint: 'Dal catasto o dalla mappa.',
            },
            usableArea: {
              label: 'Superficie utile totale (BRA)',
              hint: 'Superficie di pavimento totale di tutti i piani, misurata all’interno delle pareti esterne.',
            },
            heatedArea: {
              label: 'Superficie utile riscaldata',
              hint: 'La superficie riscaldata a oltre 15 °C.',
            },
            floorHeight: {
              label: 'Altezza media dei piani',
              hint: 'Lascia vuoto se non lo sai, verrà usato il valore standard della categoria.',
            },
          },
          options: {
            categories: {
              kontor: 'Edificio per uffici',
              lettIndustri: 'Industria leggera',
              lager: 'Magazzino',
              forretning: 'Edificio commerciale',
              skole: 'Edificio scolastico',
              hotell: 'Edificio alberghiero',
            },
            subcategories: {
              lettindustriLager: 'Industria leggera e magazzino',
              verksted: 'Officina',
              produksjon: 'Capannone di produzione',
            },
          },
          knowMore: 'Sai di più sulle superfici?',
        },
        envelope: {
          nav: "Involucro dell'edificio",
          title: "Involucro dell'edificio",
          lead: "Il modo in cui sono costruite le pareti esterne determina quanto calore perde l'edificio. Scegli l'opzione più simile.",
          sections: {
            walls: {
              title: 'Pareti esterne',
              description:
                'Materiale e spessore determinano quanto calore lasciano uscire le pareti.',
            },
            more: {
              title: "Cos'altro ha l'edificio?",
              description:
                'Ciò che spunti qui apre passaggi dedicati nel menu.',
            },
          },
          fields: {
            construction: {
              label: 'Costruzione',
              hint: 'Il tipo più comune se ce ne sono diversi.',
            },
            insulation: {
              label: "Spessore dell'isolamento",
              hint: "Lascia vuoto se non lo sai — useremo lo standard dell'anno di costruzione.",
            },
          },
          options: {
            walls: {
              tre: 'Legno',
              mur: 'Muratura',
              staal: 'Acciaio',
              betong: 'Calcestruzzo',
            },
            concrete: { betong10: '10 cm', betong20: '20 cm' },
          },
          checks: {
            basement: { label: 'Seminterrato o piano interrato' },
            knowWindows: { label: 'Finestre' },
            doors: { label: 'Porte' },
            gates: { label: 'Portoni' },
          },
          aside: {
            title: 'Pareti e dispersione termica',
            body: "Gran parte del calore di un edificio si disperde attraverso le pareti. Materiale e isolamento dicono al consulente quanto bene l'edificio trattiene il calore. Scegli l'opzione più simile, al resto pensa il consulente.",
          },
        },
        basement: {
          nav: 'Seminterrato',
          title: 'Seminterrato',
          lead: "Il piano interrato viene calcolato diversamente perché confina con il terreno e non con l'aria esterna.",
          aside: {
            title: 'Seminterrato a contatto con il terreno',
            body: "Un seminterrato confina con il terreno, non con l'aria esterna. Il terreno mantiene una temperatura più stabile durante l'anno, quindi la dispersione di calore si calcola diversamente rispetto alle pareti fuori terra. Se il seminterrato è riscaldato decide se conta nella superficie riscaldata. Inserisci ciò che sai, i campi vuoti ricevono valori predefiniti.",
          },
          section: {
            title: 'Il piano interrato',
            description:
              'Solo ciò che sai. I campi vuoti ricevono valori predefiniti.',
          },
          checks: {
            heated: {
              label: 'Il piano interrato è riscaldato',
              description:
                'Un seminterrato non riscaldato viene considerato come zona tampone verso il terreno.',
            },
          },
          fields: {
            floorArea: { label: 'Superficie del seminterrato' },
            wallLength: { label: 'Lunghezza delle pareti esterne' },
            floorHeight: { label: 'Altezza del piano' },
            wallThickness: { label: 'Spessore delle pareti del seminterrato' },
            depth: {
              label: 'Profondità media sotto il livello del terreno',
              hint: 'Quanto in profondità si trova il seminterrato nel terreno.',
            },
          },
          knowMore: 'Sai di più sul seminterrato?',
        },
        windows: {
          nav: 'Finestre',
          title: 'Finestre',
          lead: 'Le finestre sono responsabili di gran parte della dispersione termica — e degli apporti solari. La distribuzione per orientamento conta di più.',
          sections: { area: { title: 'Le finestre dell’edificio' } },
          checks: {
            even: {
              label:
                "Tutte le finestre sono distribuite uniformemente sull'edificio",
              description:
                'Dividiamo la superficie totale in parti uguali su quattro facciate.',
            },
          },
          fields: {
            windowType: {
              label: 'Tipo di finestra',
              hint: 'Il tipo più comune se ce ne sono diversi.',
            },
            totalArea: { label: 'Superficie totale delle finestre' },
            installYear: {
              label: 'Anno di installazione delle finestre',
              hint: "L'anno in cui sono state installate le finestre più recenti.",
            },
            north: { label: 'Nord' },
            east: { label: 'Est' },
            south: { label: 'Sud' },
            west: { label: 'Ovest' },
          },
          aside: {
            title: 'Orientamento',
            body: 'Le finestre esposte a sud lasciano entrare più calore solare e riducono il fabbisogno di riscaldamento. Verso nord si ha quasi solo dispersione termica. Per questo chiediamo per facciata.',
          },
          knowMore: 'Sai di più sulle finestre?',
        },
        doors: {
          nav: 'Porte e portoni',
          title: 'Porte e portoni',
          lead: "Porte e portoni fanno parte dell'involucro dell'edificio, e il tipo dice molto sulla dispersione di calore. Inserisci ciò che sai o ricordi, il resto riceve valori predefiniti.",
          only: {
            doors: {
              nav: 'Porte',
              title: 'Porte',
              lead: "Le porte esterne fanno parte dell'involucro dell'edificio, e il tipo dice molto sulla dispersione di calore. Inserisci ciò che sai o ricordi, il resto riceve valori predefiniti.",
              aside: {
                title: 'Porte e dispersione di calore',
                body: "Una porta esterna disperde più calore della parete che la circonda. Il tipo di porta indica al consulente all'incirca quanto bene isola. Ciò che non sai, il consulente lo calcola dall'anno di costruzione e dai valori predefiniti.",
              },
            },
            gates: {
              nav: 'Portoni',
              title: 'Portoni',
              lead: "I portoni sono spesso le aperture più grandi dell'involucro dell'edificio, e il tipo dice molto sulla dispersione di calore. Inserisci ciò che sai o ricordi, il resto riceve valori predefiniti.",
              aside: {
                title: 'Portoni e dispersione di calore',
                body: "I portoni sono spesso le aperture più grandi dell'edificio, e restano spesso aperti per periodi. Il tipo di portone indica al consulente all'incirca quanto bene isolano. Ciò che non sai, il consulente lo calcola dall'anno di costruzione e dai valori predefiniti.",
              },
            },
          },
          aside: {
            title: 'Porte, portoni e dispersione di calore',
            body: "Porte e portoni disperdono più calore della parete che li circonda, e i portoni restano spesso aperti per periodi. Il tipo indica al consulente all'incirca quanto bene isolano. Ciò che non sai, il consulente lo calcola dall'anno di costruzione e dai valori predefiniti.",
          },
          sections: {
            doors: {
              title: 'Porte',
              description: 'Porte esterne per le persone.',
            },
            gates: {
              title: 'Portoni',
              description: 'Portoni carrabili, portoni di carico e simili.',
            },
          },
          fields: {
            doorType: {
              label: 'Tipo di porta',
              hint: 'Il tipo più comune se ce ne sono diversi.',
            },
            installYear: { label: 'Anno di installazione' },
            uValue: {
              label: 'Valore U, media',
              hint: 'Lascia vuoto se non lo sai.',
            },
            gateType: {
              label: 'Tipo di portone',
              hint: 'Il tipo più comune se ce ne sono diversi.',
            },
            area: { label: 'Superficie' },
          },
          options: {
            doorTypes: {
              isolertStaal: 'Porta in acciaio',
              glass: 'Porta a vetri',
              tre: 'Porta in legno',
              aluminium: 'Porta in alluminio',
            },
            gateTypes: {
              leddportIsolert: 'Portone sezionale isolato',
              leddport: 'Portone sezionale non isolato',
              rulleport: 'Serranda avvolgibile',
              hurtigport: 'Portone rapido',
            },
          },
          knowMoreDoors: 'Sai di più sulle porte?',
          knowMoreGates: 'Sai di più sui portoni?',
        },
        energySources: {
          nav: 'Fonti energetiche',
          title: 'Fonti energetiche',
          lead: "Quali fonti energetiche ha l'edificio? Le scelte qui aprono i passaggi successivi.",
          sections: {
            delivered: {
              title: 'Energia fornita',
              description: "Spunta tutto ciò che è collegato all'edificio.",
            },
            own: { title: 'Produzione propria' },
          },
          checks: {
            electricity: {
              label: 'Elettricità',
              description:
                "Tutti gli edifici hanno l'elettricità. Solo elettricità dà un calcolo semplificato.",
            },
            districtHeating: {
              label: 'Teleriscaldamento',
              description:
                'Apre il passaggio Impianto di riscaldamento centralizzato.',
            },
            heatPump: {
              label: 'Pompa di calore',
              description: 'Apre il passaggio Pompa di calore.',
            },
            fossil: {
              label: 'Gasolio, gas o bio',
              description: 'Apre il passaggio Caldaia.',
            },
            other: {
              label: 'Altre fonti energetiche',
              description:
                "Descrivile nel campo commenti dell'ultimo passaggio.",
            },
            solar: {
              label: "L'edificio ha un impianto fotovoltaico",
              description: 'Apre il passaggio Pannelli solari.',
            },
          },
          aside: {
            title: 'Riscaldamento centralizzato',
            body: 'Teleriscaldamento, pompa di calore e caldaie possono essere tutti collegati a un unico impianto di riscaldamento centralizzato. Nel passaggio successivo chiediamo come si dividono riscaldamento e acqua calda.',
          },
        },
        centralHeating: {
          nav: 'Impianto di riscaldamento centralizzato',
          title: 'Impianto di riscaldamento centralizzato',
          lead: "Fonti energetiche selezionate — ecco come sono configurate nell'impianto di riscaldamento centralizzato.",
          sections: {
            plant: { title: "L'impianto" },
            districtHeating: {
              title: 'Teleriscaldamento',
              description:
                'Come viene usato il teleriscaldamento nell’edificio.',
            },
          },
          fields: {
            location: {
              label: 'Posizione',
              hint: 'Dove si trova la centrale termica.',
            },
            installYear: { label: 'Anno di installazione' },
            connectedTo: {
              label: 'Collegato a',
              hint: "Dove va l'acqua.",
            },
          },
          options: {
            locations: {
              tekniskRom: 'Locale tecnico',
              kjeller: 'Seminterrato',
              tak: 'Tetto',
              egetBygg: 'Edificio separato',
            },
            connections: {
              oppvarming: 'Riscaldamento',
              oppvarmingVent: 'Riscaldamento e ventilazione',
            },
          },
          checks: {
            forHeating: { label: 'Riscaldamento degli ambienti' },
            forHotWater: { label: 'Acqua calda sanitaria' },
          },
          aside: {
            title: 'Il calore parte dalla centrale',
            body: "L'impianto di riscaldamento centralizzato porta il calore delle fonti energetiche nell'edificio sotto forma di acqua. Dove si trova la centrale, e se l'acqua scalda anche l'aria di ventilazione, determina quanto calore si perde lungo il percorso. Se ti mancano i dati, usiamo valori predefiniti.",
          },
        },
        heatPump: {
          nav: 'Pompa di calore',
          title: 'Pompa di calore',
          lead: 'Tipo e prestazioni della pompa di calore. Potenza e consumo si trovano di solito sulla targhetta o nel libretto di manutenzione.',
          sections: {
            plant: { title: "L'impianto" },
            connection: { title: 'Collegamento' },
          },
          fields: {
            type: { label: 'Tipo' },
            installYear: { label: 'Anno di installazione' },
            power: {
              label: 'Potenza',
              hint: 'Potenza termica nominale dalla targhetta.',
            },
            annualUse: {
              label: 'Consumo annuo',
              hint: 'Dal contatore elettrico o dal sistema di controllo, se disponibile.',
            },
          },
          options: {
            types: {
              luftLuft: 'Aria–aria',
              luftVann: 'Aria–acqua',
              vaeskeVann: 'Acqua glicolata–acqua',
              avtrekk: 'Pompa di calore ad aria di estrazione',
            },
          },
          checks: {
            connected: {
              label:
                "La pompa di calore è collegata all'impianto di riscaldamento centralizzato",
              description:
                'La quota viene impostata nel passaggio Riscaldamento e raffrescamento.',
            },
          },
          knowMore: 'Sai di più sulla pompa di calore?',
          aside: {
            title: 'Più calore che elettricità',
            body: "Una pompa di calore preleva calore dall'aria, dall'acqua o dal terreno e fornisce più chilowattora di calore di quanti ne consuma in elettricità. Tipo, potenza ed età ne determinano l'efficienza, e questo incide direttamente sulla classe energetica. Se ti mancano i numeri, usiamo valori predefiniti.",
          },
        },
        boiler: {
          nav: 'Caldaia',
          title: 'Caldaia',
          lead: 'La caldaia alimentata a gasolio, gas o biomassa. La potenza si trova di solito sulla targhetta.',
          sections: { plant: { title: 'La caldaia' } },
          fields: {
            fuelType: { label: 'Tipo di caldaia' },
            power: {
              label: 'Potenza a pieno carico',
              hint: 'Dalla targhetta o dalla documentazione.',
            },
          },
          options: {
            fuelTypes: { olje: 'Gasolio', gass: 'Gas', bio: 'Biomassa' },
          },
          aside: {
            title: 'Il combustibile conta in modo diverso',
            body: "Olio, gas e biomassa hanno pesi diversi nell'attestato energetico, quindi il tipo di caldaia influisce sia sulla classe energetica sia sul voto del riscaldamento. La potenza indica quanta parte del fabbisogno termico la caldaia può coprire. Se ti mancano i numeri, usiamo valori predefiniti.",
          },
        },
        solar: {
          nav: 'Pannelli solari',
          title: 'Pannelli solari',
          lead: "L'elettricità autoprodotta viene detratta dall'energia fornita nell'attestato.",
          sections: {
            plant: {
              title: "L'impianto fotovoltaico",
              description:
                "I numeri si trovano di solito nella documentazione dell'installatore o nell'app dell'impianto.",
            },
            hotWater: { title: 'Acqua calda' },
          },
          fields: {
            installedPower: {
              label: 'Potenza installata',
              hint: "Si trova nella documentazione dell'impianto.",
            },
            installYear: { label: 'Anno di installazione' },
            annualProduction: {
              label: 'Produzione annua',
              hint: "Dall'inverter o dall'app dell'impianto.",
            },
            panelArea: { label: 'Superficie dei pannelli' },
          },
          checks: {
            hotWaterConnected: {
              label: "L'acqua calda è collegata all'impianto centralizzato",
              description:
                "Vedi fonti energetiche. Altrimenti l'acqua calda viene considerata elettrica.",
            },
          },
          aside: {
            title: 'La tua energia conta',
            body: "L'elettricità dei pannelli solari copre parte di quella che l'edificio consuma, e questo può dare un'etichetta energetica migliore. Per questo dobbiamo sapere quanto è grande l'impianto. Se ti mancano i numeri, scrivilo nel campo commenti dell'ultimo passaggio.",
          },
          knowMore: 'Sai di più sull’impianto solare?',
        },
        ventilation: {
          nav: 'Ventilazione',
          systemTitle: 'Impianto {number}',
          title: 'Ventilazione',
          lead: "L'edificio ha un impianto di ventilazione?",
          sections: {
            type: {
              title: 'Impianto di ventilazione',
              description:
                'Solo la ventilazione bilanciata richiede altri dettagli.',
            },
            plant: {
              title: "L'impianto",
              description:
                "Un'unità immette aria fresca ed estrae l'aria usata, spesso con recupero di calore.",
            },
            capacity: {
              title: 'Capacità — per impianto',
              description:
                'Se la capacità supera il valore minimo, deve essere indicata.',
            },
            maintenance: { title: 'Manutenzione' },
          },
          fields: {
            hasSystems: { label: 'L’edificio ha un impianto di ventilazione?' },
            count: {
              label: 'Numero di impianti',
              hint: 'Ottieni un gruppo di campi per ogni impianto.',
            },
            type: { label: 'Tipo' },
            installYear: { label: 'Anno di installazione' },
            airflowOperating: {
              label: "Portata d'aria in orario di esercizio",
            },
            airflowOff: { label: "Portata d'aria fuori orario di esercizio" },
            lastMaintenance: {
              label: "Data dell'ultima manutenzione",
              hint: 'Dal rapporto di manutenzione.',
            },
            regularMaintenance: {
              label: "Manutenzione regolare dell'impianto?",
            },
            moreInfo: {
              label:
                'Hai altre informazioni sulla ventilazione per il consulente?',
              hint: 'Sostituzione filtri, orari di esercizio, anomalie note.',
            },
            heatRecovery: {
              label: 'Efficienza del recupero di calore',
              hint: 'Dalla documentazione dell’unità.',
            },
          },
          checks: {
            exhaustHeatPump: {
              label: 'Pompa di calore ad aria espulsa collegata alla centrale',
            },
            extractHeatPump: {
              label:
                'Pompa di calore ad aria di estrazione collegata alla centrale',
            },
          },
          options: {
            types: {
              avtrekk: 'Estrazione meccanica',
              balansert: 'Ventilazione bilanciata',
            },
            typeDescriptions: {
              avtrekk: "Gran parte dell'edificio ha un'estrazione meccanica.",
            },
          },
          aside: {
            title: 'Aria e calore',
            body: "La ventilazione sostituisce l'aria interna usata con aria fresca dall'esterno. Un impianto che recupera il calore dall'aria in uscita fa risparmiare molta energia. Se ti mancano i numeri, usiamo valori predefiniti.",
          },
          knowMore: 'Sai di più sulla ventilazione?',
        },
        heating: {
          nav: 'Riscaldamento e raffrescamento',
          title: 'Riscaldamento e raffrescamento',
          lead: 'Le proposte qui sotto si basano sulle fonti energetiche e sulla ventilazione che hai scelto. Inserisci la quota coperta da ciascuna soluzione, se la conosci.',
          groups: {
            electric: { title: 'Riscaldamento elettrico' },
            central: { title: 'Riscaldamento centralizzato' },
          },
          options: {
            electric: {
              panelHeaters: 'Pannelli radianti',
              convectors: 'Convettori',
              electricBoiler: 'Caldaia elettrica con bollitore',
              electricFloor: 'Riscaldamento a pavimento',
              ventilationHeat: 'Riscaldamento tramite ventilazione',
              airToAir: 'Pompa di calore aria–aria',
            },
            central: {
              radiators: 'Radiatori',
              convectors: 'Convettori',
              waterFloor: 'Riscaldamento a pavimento',
              ventilationHeat: 'Riscaldamento tramite ventilazione',
            },
          },
          sections: { cooling: { title: 'Raffrescamento' } },
          checks: {
            hasCooling: {
              label: "L'edificio ha il raffrescamento",
              description:
                'Gruppo frigorifero, teleraffrescamento o pompa di calore in modalità raffrescamento.',
            },
          },
          aside: {
            title: 'Inserisci ciò che sai',
            body: 'Se non lo sai, non devi compilare i campi. Inserisci ciò che sai, di cui sai qualcosa o valori approssimativi. Più dettagli danno al consulente energetico una base migliore.',
          },
          singleShare: 'Ipotizziamo che questa copra tutto il riscaldamento.',
        },
        summary: {
          nav: 'Riepilogo e invio',
          title: 'Riepilogo e invio',
          lead: "L'attestato energetico è più preciso — e spesso migliore — quando più campi sono compilati.",
          alert: {
            title: '{count} passaggi usano valori predefiniti',
            body: "Dati insufficienti fanno sì che la certificazione energetica venga effettuata su informazioni limitate. Parte degli impianti tecnici e dell'edificio viene allora calcolata con valori predefiniti. Puoi inviare ora, oppure tornare indietro e compilare di più per un'etichetta più precisa.",
          },
          registered: 'Ciò che hai registrato',
          confirmFirst:
            'Conferma che le informazioni sono fornite in buona fede prima di inviare.',
          sections: { advisor: { title: 'Per il consulente' } },
          fields: {
            note: {
              label:
                "C'è qualcosa che il consulente dovrebbe sapere su flussi energetici e consumi?",
              hint: "Per esempio: parti dell'edificio sono vuote, riduzione notturna e nel fine settimana, sostituzioni recenti, perdite note.",
            },
          },
          checks: {
            goodFaith: {
              label:
                'Tutte le informazioni sono state registrate al meglio delle mie conoscenze e in buona fede',
              description:
                "Il consulente usa le tue risposte come base per l'attestato energetico. Potrai correggere in seguito se qualcosa era sbagliato.",
            },
          },
          aside: {
            eyebrow: 'Cosa succede ora?',
            title: 'La tua registrazione va al consulente',
            body: "Un consulente energetico controlla le tue risposte e invia l'attestato energetico a Enova. Nessuno deve visitare l'edificio. Riceverai un avviso quando l'attestato sarà pronto.",
          },
        },
      },
      knowInstallYear: 'Conosci l’anno di installazione?',
      assumeBuildYear: 'Ipotizziamo che sia dell’anno {year}.',
      buildYearWord: 'di costruzione',
      assumeStandard: 'Ipotizziamo valori standard.',
    },
  },
};

export default ITALIAN;
